// import { Typography } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import backrrImage from "assets/Backrr_full_logo.png";

// import Cookies from "js-cookie";
// import React from "react";

// const deadline = new Date("2025-07-21T23:45:00");

// function getTimeRemaining(endTime) {
//     const total = Date.parse(endTime) - Date.now();
//     const seconds = Math.floor((total / 1000) % 60);
//     const minutes = Math.floor((total / 1000 / 60) % 60);
//     const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
//     const days = Math.floor(total / (1000 * 60 * 60 * 24));
//     return {
//         total,
//         days,
//         hours,
//         minutes,
//         seconds,
//     };
// }

// export default function Giveaway() {
//     const [timeLeft, setTimeLeft] = useState(getTimeRemaining(deadline));

//     useEffect(() => {
//         const timer = setInterval(() => {
//             setTimeLeft(getTimeRemaining(deadline));
//         }, 1000);
//         return () => clearInterval(timer);
//     }, []);

//     return (
//         <div style={{
//             minHeight: "100dvh",
//             background: "linear-gradient(180deg, #FFD600 0%, #FFE066 100%)",
//             position: "relative",
//             overflow: "hidden",
//             fontFamily: "Montserrat, Arial, sans-serif"
//         }}>
//             {/* Back Button */}
//             <div style={{ padding: "32px 0 0 32px", fontSize: "20px", color: "#444", display: "flex", alignItems: "center" }}>
//                 {/* <span style={{ fontSize: "24px", marginRight: "8px" }}>←</span>
//                 <span>Back</span> */}
//                 {/* <BackrrLogoImage /> */}
//                 <img src={backrrImage} />
//             </div>

//             {/* Title */}
//             <div style={{ textAlign: "center", marginTop: "32px" }}>
//                 <Typography sx={{
//                     // fontWeight: "bold",
//                     fontSize: { xs: "2rem", sm: "2rem", md: "2rem", lg: "3rem" }, color: "#111", letterSpacing: "2px", fontWeight: 700,
//                     lineHeight: "40px",
//                 }}>
//                     Pranay's Birthday Giveaway
//                 </Typography>
//                 {/* <span style={{ fontSize: "40px", color: "#3887FE", fontStyle: "italic", marginLeft: "16px" }}>
//                     party
//                 </span> */}
//             </div>

//             {/* Center Box */}
//             <div style={{
//                 margin: "48px auto 0 auto",
//                 background: "#fff",
//                 borderRadius: "8px",
//                 boxShadow: "0 4px 24px rgba(0,0,0,0.05)",
//                 width: "60%",
//                 minWidth: "340px",
//                 maxWidth: "700px",
//                 padding: "32px 0",
//                 position: "relative",
//                 zIndex: 2
//             }}>
//                 <div style={{ textAlign: "center", fontSize: "32px", fontWeight: "600", color: "#222" }}>
//                     Register for <span style={{ color: "#3887FE", fontStyle: "italic", fontWeight: "700" }}>giveaway</span>
//                 </div>
//             </div>

//             {/* Countdown */}
//             <div style={{ display: "flex", justifyContent: "center", marginTop: "32px", gap: "32px", scale: "0.7" }}>
//                 {["days", "hours", "minutes", "seconds"].map((unit, idx) => (
//                     <div key={unit} style={{ textAlign: "center" }}>
//                         <div style={{
//                             background: "#3887FE",
//                             color: "#fff",
//                             fontWeight: "bold",
//                             fontSize: "36px",
//                             borderRadius: "8px",
//                             width: "80px",
//                             height: "70px",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             margin: "0 auto"
//                         }}>
//                             {String(timeLeft[unit]).padStart(2, "0")}
//                         </div>
//                         <div style={{ fontSize: "16px", color: "#222", marginTop: "8px" }}>{unit}</div>
//                     </div>
//                 ))}
//             </div>

//             {/* Last day text */}
//             <div style={{ textAlign: "center", marginTop: "15px", fontSize: "28px", color: "#222", scale: "0.7" }}>
//                 Last day to register 21 July 11:45pm
//             </div>

//             {/* Register Button */}
//             <div style={{ textAlign: "center", marginTop: "15px", scale: "0.7" }}>
//                 <button style={{
//                     background: "#3887FE",
//                     color: "#fff",
//                     fontWeight: "bold",
//                     fontSize: "24px",
//                     border: "none",
//                     borderRadius: "40px",
//                     padding: "18px 48px",
//                     cursor: "pointer",
//                     boxShadow: "0 4px 16px rgba(56,135,254,0.15)"
//                 }}>
//                     Register Now
//                 </button>
//             </div>

//             {/* Decorative icons */}
//             <div>
//                 {/* Example SVG icons, you can add more or use images */}
//                 <svg style={{ position: "absolute", left: "40px", top: "180px" }} width="60" height="60">
//                     <circle cx="30" cy="30" r="25" stroke="#FF8A65" strokeWidth="5" fill="none" />
//                 </svg>
//                 <svg style={{ position: "absolute", left: "180px", top: "260px" }} width="40" height="40">
//                     <path d="M20 10 Q25 20 20 30 Q15 20 20 10" stroke="#4DD0E1" strokeWidth="3" fill="none" />
//                     <circle cx="20" cy="35" r="2" fill="#4DD0E1" />
//                 </svg>
//                 <svg style={{ position: "absolute", right: "60px", top: "220px" }} width="40" height="40">
//                     <rect x="10" y="10" width="20" height="20" rx="6" fill="#3887FE" opacity="0.2" />
//                 </svg>
//                 <svg style={{ position: "absolute", right: "120px", top: "120px" }} width="40" height="40">
//                     <rect x="10" y="10" width="20" height="20" rx="6" fill="#4DD0E1" opacity="0.2" />
//                 </svg>
//                 <svg style={{ position: "absolute", right: "80px", bottom: "120px" }} width="40" height="40">
//                     <rect x="10" y="10" width="20" height="20" rx="6" fill="#FF8A65" opacity="0.2" />
//                 </svg>
//                 <svg style={{ position: "absolute", left: "60px", bottom: "80px" }} width="40" height="40">
//                     <circle cx="20" cy="20" r="16" stroke="#FF8A65" strokeWidth="4" fill="none" />
//                 </svg>
//                 {/* Add more SVGs for more decorations as needed */}
//             </div>
//         </div>
//     );
// }

// import { useState, useEffect } from 'react';
// import {
//   Box, Typography, Container, Button, Card, CardContent,
//   Accordion, AccordionSummary, AccordionDetails, Grid, Avatar, Link
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import GiftIcon from '@mui/icons-material/CardGiftcard';
// import RocketIcon from '@mui/icons-material/RocketLaunch';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import PersonIcon from '@mui/icons-material/Person';
// import TargetIcon from '@mui/icons-material/TrackChanges';
// import WarningAmberIcon from '@mui/icons-material/WarningAmber';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import MailOutlineIcon from '@mui/icons-material/MailOutline';
// import LaunchIcon from '@mui/icons-material/OpenInNew';
// // import pranayProfile from '@/assets/pranay-profile.png'; // Replace with correct path
// import pranayProfile from 'assets/backrr_startup_banner.webp'; // Replace with correct path

// const FloatingEmojis = () => {
//   const [emojis] = useState(['🎁', '🎉', '⭐', '🚀', '🎈', '🌟', '✨']);

//   useEffect(() => {
//     const createFloatingEmoji = () => {
//       const emoji = emojis[Math.floor(Math.random() * emojis.length)];
//       const element = document.createElement('div');
//       element.innerHTML = emoji;
//       element.style.position = 'fixed';
//       element.style.fontSize = '2rem';
//       element.style.left = Math.random() * window.innerWidth + 'px';
//       element.style.top = '100dvh';
//       element.style.animation = `float ${Math.random() * 3 + 2}s linear forwards`;
//       document.body.appendChild(element);
//       setTimeout(() => element.remove(), 5000);
//     };

//     const interval = setInterval(createFloatingEmoji, 2000);
//     return () => clearInterval(interval);
//   }, [emojis]);

//   return null;
// };

// const CountdownTimer = () => {
//   const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

//   useEffect(() => {
//     const targetDate = new Date('2025-07-31T23:59:59+05:30').getTime();
//     const timer = setInterval(() => {
//       const now = new Date().getTime();
//       const difference = targetDate - now;
//       if (difference > 0) {
//         setTimeLeft({
//           days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//           hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
//           minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
//           seconds: Math.floor((difference % (1000 * 60)) / 1000),
//         });
//       }
//     }, 1000);
//     return () => clearInterval(timer);
//   }, []);

//   const TimeBox = ({ label, value }) => (
//     <Box textAlign="center" p={2} bgcolor="primary.main" color="white" borderRadius={2} minWidth={80}>
//       <Typography variant="h4">{String(value).padStart(2, '0')}</Typography>
//       <Typography variant="caption">{label}</Typography>
//     </Box>
//   );

//   return (
//     <Box display="flex" gap={2} justifyContent="center">
//       <TimeBox label="Days" value={timeLeft.days} />
//       <TimeBox label="Hours" value={timeLeft.hours} />
//       <TimeBox label="Minutes" value={timeLeft.minutes} />
//       <TimeBox label="Seconds" value={timeLeft.seconds} />
//     </Box>
//   );
// };

// const FAQSection = () => {
//   const faqs = [
//     { question: "How will the winners be selected?", answer: "Based on startup potential, traction, team strength, and fit with our investor network." },
//     { question: "Do I need to be a paid Backrr user?", answer: "No, both new and existing Backrr users can apply." },
//     { question: "When will winners be announced?", answer: "Within 2 weeks after July 31, 2025." },
//     { question: "What is included in a Premium Backrr account?", answer: "Advanced analytics, investor matching, and more." },
//     { question: "Can I apply if I'm not based in India?", answer: "Only Indian startup founders are eligible." },
//     { question: "What if I don't have 50% profile completion?", answer: "You'll need to complete 50% of your Backrr profile to be considered." },
//     { question: "Is there any cost to participate?", answer: "No, it's completely free!" }
//   ];

//   return (
//     <Box py={8} bgcolor="#f9f9f9">
//       <Container maxWidth="md">
//         <Typography variant="h4" align="center" gutterBottom>Frequently Asked Questions</Typography>
//         {faqs.map((faq, index) => (
//           <Accordion key={index}>
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Typography fontWeight="bold">{faq.question}</Typography>
//             </AccordionSummary>
//             <AccordionDetails>
//               <Typography color="text.secondary">{faq.answer}</Typography>
//             </AccordionDetails>
//           </Accordion>
//         ))}
//       </Container>
//     </Box>
//   );
// };

// const IndexPage = () => {
//   return (
//     <Box minHeight="100dvh">
//       <FloatingEmojis />

//       {/* Hero Section */}
//       <Box py={10} bgcolor="#FFF7E6" textAlign="center">
//         <Container>
//           <Typography variant="h2" fontWeight="bold">Pranay's Birthday Giveaway</Typography>
//           <Box mt={2}>
//             <Button variant="contained" color="primary" size="large">Founder of Backrr</Button>
//           </Box>
//           <Typography variant="h5" mt={3}>20 startups will win ₹2 Lakhs in Mentorship & Resources</Typography>
//           <Typography variant="body1" mt={1} color="text.secondary">
//             Registration closes July 31, 2025, 11:59 PM IST
//           </Typography>

//           <Box mt={4}><CountdownTimer /></Box>

//           <Box mt={4}>
//             <Button
//               variant="contained"
//               size="large"
//               color="primary"
//               endIcon={<LaunchIcon />}
//               href="https://startup.backrr.com/bdaygiveaway"
//               target="_blank"
//             >
//               <RocketIcon fontSize="small" style={{ marginRight: 8 }} />
//               Register Now
//             </Button>
//           </Box>

//           <Box mt={2} display="flex" alignItems="center" justifyContent="center" gap={1} color="warning.main">
//             <WarningAmberIcon />
//             <Typography fontWeight="bold">Only first 100 qualified startups considered. Spots filling fast!</Typography>
//           </Box>
//         </Container>
//       </Box>

//       {/* Bonus */}
//       <Box py={8} bgcolor="primary.dark" color="white" textAlign="center">
//         <Typography variant="h4" gutterBottom>Bonus for ALL Applicants</Typography>
//         <Typography variant="h6">Free access to 900+ successful startup pitch decks!</Typography>
//       </Box>

//       {/* What You'll Win */}
//       <Box py={8}>
//         <Container>
//           <Typography variant="h4" align="center" gutterBottom>
//             <GiftIcon /> What You'll Win
//           </Typography>
//           <Grid container spacing={3} mt={2}>
//             {[
//               { icon: <GiftIcon />, title: "Premium Backrr Account", desc: "1 Year access" },
//               { icon: <AccessTimeIcon />, title: "1-hour Mentorship Call", desc: "With Pranay Mathur" },
//               { icon: <PersonIcon />, title: "Warm VC Intros", desc: "10 curated investor connects" },
//               { icon: <TargetIcon />, title: "Enhanced Visibility", desc: "Priority placement" },
//             ].map((item, index) => (
//               <Grid item xs={12} md={3} key={index}>
//                 <Card>
//                   <CardContent sx={{ textAlign: 'center' }}>
//                     <Box mb={2} color="primary.main">{item.icon}</Box>
//                     <Typography fontWeight="bold">{item.title}</Typography>
//                     <Typography variant="body2" color="text.secondary">{item.desc}</Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Who Can Apply */}
//       <Box py={8} bgcolor="#f4f4f4">
//         <Container>
//           <Typography variant="h4" align="center" gutterBottom>
//             <TargetIcon /> Who Can Apply?
//           </Typography>
//           <Grid container spacing={3} mt={2}>
//             {[
//               ["Indian Startup Founders", "Pre-seed or Seed stage, India based"],
//               ["MVP Ready", "Have a working MVP & traction"],
//               ["All Backrr Users Welcome", "New and existing users"],
//               ["Complete Your Profile", "50% profile completion required"],
//             ].map(([title, desc], index) => (
//               <Grid item xs={12} md={3} key={index}>
//                 <Card>
//                   <CardContent sx={{ textAlign: 'center' }}>
//                     <Typography fontWeight="bold" color="primary.main">{title}</Typography>
//                     <Typography variant="body2" color="text.secondary">{desc}</Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* About Pranay */}
//       <Box py={8}>
//         <Container>
//           <Typography variant="h4" align="center" gutterBottom>About Pranay Mathur</Typography>
//           <Grid container spacing={4} alignItems="center">
//             <Grid item xs={12} md={4}>
//               <Avatar src={pranayProfile} sx={{ width: 240, height: 240, mx: 'auto' }} variant="rounded" />
//             </Grid>
//             <Grid item xs={12} md={8}>
//               <Typography paragraph>
//                 Pranay Mathur is the Founder & CEO of Backrr. With a decade of experience and 2000+ startups mentored,
//                 he's bridging the gap between innovation and capital in India's startup ecosystem.
//               </Typography>
//               <Box display="flex" gap={2}>
//                 <Button variant="outlined" startIcon={<LinkedInIcon />} href="https://linkedin.com/in/pranaymathur" target="_blank">
//                   LinkedIn
//                 </Button>
//                 <Button variant="outlined" startIcon={<MailOutlineIcon />} href="mailto:pranay@backrr.com">
//                   Email
//                 </Button>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* FAQ */}
//       <FAQSection />

//       {/* Final CTA */}
//       <Box py={8} bgcolor="#FFF7E6" textAlign="center">
//         <Container>
//           <Typography variant="h4" gutterBottom>Don't Miss This Opportunity!</Typography>
//           <Typography variant="body1" mb={4}>
//             Join hundreds of successful Indian startups who’ve started their journey with Backrr.
//           </Typography>
//           <Button
//             variant="contained"
//             color="primary"
//             size="large"
//             endIcon={<LaunchIcon />}
//             href="https://startup.backrr.com/bdaygiveaway"
//             target="_blank"
//           >
//             <GiftIcon fontSize="small" sx={{ mr: 1 }} />
//             Register Now
//           </Button>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default IndexPage;

// import React, { useState } from 'react';

// const CompleteLandingPage = () => {
//   const [openFAQIndex, setOpenFAQIndex] = useState(0);
//   const [countdownTime, setCountdownTime] = useState({
//     days: 10,
//     hours: 9,
//     minutes: 26,
//     seconds: 10
//   });

//   const toggleFAQ = (index) => {
//     setOpenFAQIndex(openFAQIndex === index ? -1 : index);
//   };

//   // Responsive styles
//   const responsiveStyles = {
//     container: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       padding: '0 20px'
//     },
//     gridResponsive: {
//       display: 'grid',
//       gap: '30px',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))'
//     },
//     flexResponsive: {
//       display: 'flex',
//       flexWrap: 'wrap',
//       gap: '20px',
//       justifyContent: 'center',
//       alignItems: 'center'
//     }
//   };

//   // Birthday Giveaway Section
//   const BirthdayGiveawaySection = () => (
//     <div style={{ 
//       background: 'linear-gradient(90deg, #FFE066 0%, #FFF1B8 100%)', 
//       padding: '40px 20px', 
//       fontFamily: 'system-ui, -apple-system, sans-serif', 
//       color: '#333',
//       minHeight: '100dvh',
//       display: 'flex',
//       alignItems: 'center'
//     }}>
//       <div style={{ 
//         ...responsiveStyles.container,
//         textAlign: 'center',
//         width: '100%'
//       }}>
//         <h1 style={{ 
//           fontWeight: 900, 
//           fontSize: 'clamp(2rem, 5vw, 3rem)', 
//           marginBottom: '10px',
//           color: '#333'
//         }}>
//           Pranay's Birthday
//         </h1>

//         <h2 style={{ 
//           fontWeight: 900, 
//           fontSize: 'clamp(2rem, 5vw, 3rem)', 
//           color: '#4A5AFF', 
//           marginTop: 0, 
//           marginBottom: '20px' 
//         }}>
//           Giveaway
//         </h2>

//         <button style={{
//           background: 'linear-gradient(90deg, #4A5AFF 0%, #7C3AED 100%)',
//           borderRadius: '25px',
//           color: 'white',
//           fontWeight: 700,
//           padding: '10px 20px',
//           fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
//           border: 'none',
//           cursor: 'default',
//           marginBottom: '30px'
//         }}>
//           Founder of Backrr
//         </button>

//         <p style={{ 
//           fontSize: 'clamp(1rem, 3vw, 1.2rem)', 
//           marginBottom: '15px',
//           fontWeight: '500'
//         }}>
//           20 startups will win ₹2 Lakhs in Mentorship & Resources
//         </p>

//         <p style={{ 
//           fontSize: 'clamp(0.9rem, 2.5vw, 1rem)', 
//           fontWeight: 600, 
//           marginBottom: '30px',
//           color: '#666'
//         }}>
//           Registration closes July 31, 2025, 11:59 PM IST
//         </p>

//         <div style={{ 
//           ...responsiveStyles.flexResponsive,
//           marginBottom: '40px'
//         }}>
//           {[
//             { value: countdownTime.days, label: 'DAYS' },
//             { value: countdownTime.hours, label: 'HOURS' },
//             { value: countdownTime.minutes, label: 'MINUTES' },
//             { value: countdownTime.seconds, label: 'SECONDS' }
//           ].map((item, index) => (
//             <div key={index} style={{ 
//               background: '#4A5AFF', 
//               color: 'white', 
//               padding: 'clamp(15px, 4vw, 20px) clamp(20px, 5vw, 30px)', 
//               borderRadius: '10px',
//               minWidth: 'clamp(60px, 15vw, 80px)',
//               textAlign: 'center'
//             }}>
//               <div style={{ fontWeight: 800, fontSize: 'clamp(1.5rem, 4vw, 2rem)' }}>
//                 {item.value.toString().padStart(2, '0')}
//               </div>
//               <div style={{ fontSize: 'clamp(0.7rem, 2vw, 0.8rem)', textTransform: 'uppercase', letterSpacing: '1px' }}>
//                 {item.label}
//               </div>
//             </div>
//           ))}
//         </div>

//         <button style={{
//           background: 'linear-gradient(90deg, #4A5AFF 0%, #7C3AED 100%)',
//           color: 'white',
//           borderRadius: '30px',
//           padding: 'clamp(12px, 3vw, 15px) clamp(25px, 5vw, 35px)',
//           fontWeight: 'bold',
//           fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
//           cursor: 'pointer',
//           border: 'none',
//           display: 'inline-flex',
//           alignItems: 'center',
//           gap: '10px',
//           marginBottom: '30px'
//         }}>
//           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" 
//                style={{ width: 'clamp(16px, 4vw, 20px)', height: 'clamp(16px, 4vw, 20px)' }}>
//             <path d="M5.25 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM2.25 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM18.75 7.5a.75.75 0 00-1.5 0v2.25H15a.75.75 0 000 1.5h2.25v2.25a.75.75 0 001.5 0v-2.25H21a.75.75 0 000-1.5h-2.25V7.5z"/>
//           </svg>
//           Register Now
//           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" 
//                style={{ width: 'clamp(16px, 4vw, 18px)', height: 'clamp(16px, 4vw, 18px)' }}>
//             <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
//           </svg>
//         </button>

//         <div style={{ 
//           marginTop: '20px', 
//           display: 'flex', 
//           justifyContent: 'center', 
//           alignItems: 'center', 
//           gap: '8px',
//           flexWrap: 'wrap'
//         }}>
//           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#E67E22" 
//                style={{ width: '20px', height: '20px', flexShrink: 0 }}>
//             <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
//           </svg>
//           <span style={{ 
//             fontSize: 'clamp(0.9rem, 2vw, 1rem)',
//             color: '#666',
//             fontWeight: '500',
//             textAlign: 'center'
//           }}>
//             Only first 100 qualified startups considered. Spots filling fast!
//           </span>
//         </div>
//       </div>
//     </div>
//   );

//   // Bonus Section
//   const BonusSection = () => (
//     <div style={{
//       background: 'linear-gradient(135deg, #8B5CF6 0%, #A855F7 100%)',
//       padding: 'clamp(40px, 8vw, 60px) 20px',
//       textAlign: 'center',
//       color: 'white'
//     }}>
//       <div style={responsiveStyles.container}>
//         <h1 style={{
//           fontSize: 'clamp(2rem, 5vw, 2.5rem)',
//           fontWeight: '700',
//           marginBottom: '16px',
//           fontFamily: 'system-ui, -apple-system, sans-serif'
//         }}>
//           Bonus for ALL Applicants
//         </h1>
//         <p style={{
//           fontSize: 'clamp(1rem, 3vw, 1.2rem)',
//           fontWeight: '400',
//           margin: '0',
//           opacity: '0.9',
//           lineHeight: '1.5'
//         }}>
//           Every startup that applies gets FREE access to 900+ successful startup pitch deck inspirations!
//         </p>
//       </div>
//     </div>
//   );

//   // What You'll Win Section
//   const WhatYoullWinSection = () => {
//     const benefits = [
//       {
//         icon: (
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ color: '#3B82F6' }}>
//             <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" 
//                   stroke="currentColor" strokeWidth="2" fill="currentColor"/>
//           </svg>
//         ),
//         title: 'Free Premium Backrr Account',
//         description: '1 Year access to advanced features'
//       },
//       {
//         icon: (
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ color: '#3B82F6' }}>
//             <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" 
//                   stroke="currentColor" strokeWidth="2"/>
//           </svg>
//         ),
//         title: '1-hour Mentorship Call',
//         description: 'Personal guidance from Pranay Mathur'
//       },
//       {
//         icon: (
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ color: '#3B82F6' }}>
//             <path d="M17 20H22V18C22 16.3431 20.6569 15 19 15C18.0444 15 17.1931 15.4468 16.6438 16.1429M17 20H7M17 20V18C17 15.3438 14.6562 13.1429 12 13.1429C9.34375 13.1429 7 15.3438 7 18V20M7 20H2V18C2 16.3431 3.34315 15 5 15C5.95561 15 6.80686 15.4468 7.35625 16.1429M15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7Z" 
//                   stroke="currentColor" strokeWidth="2"/>
//           </svg>
//         ),
//         title: 'Warm VC Intros',
//         description: '10 curated investor connections'
//       },
//       {
//         icon: (
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ color: '#3B82F6' }}>
//             <path d="M13 10V3L4 14H11V21L20 10H13Z" stroke="currentColor" strokeWidth="2" fill="currentColor"/>
//           </svg>
//         ),
//         title: 'Enhanced Visibility',
//         description: 'Priority placement in investor network'
//       }
//     ];

//     return (
//       <div style={{
//         backgroundColor: '#F9FAFB',
//         padding: 'clamp(60px, 10vw, 80px) 20px',
//         fontFamily: 'system-ui, -apple-system, sans-serif'
//       }}>
//         <div style={responsiveStyles.container}>
//           <div style={{ marginBottom: '60px', textAlign: 'center' }}>
//             <div style={{
//               fontSize: 'clamp(2rem, 5vw, 3rem)',
//               marginBottom: '16px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               gap: '12px',
//               flexWrap: 'wrap'
//             }}>
//               <svg width="clamp(40px, 8vw, 48px)" height="clamp(40px, 8vw, 48px)" viewBox="0 0 24 24" fill="none">
//                 <path d="M12 2L13.09 8.26L20 9L14 14.74L15.64 21.52L12 18.77L8.36 21.52L10 14.74L4 9L10.91 8.26L12 2Z" 
//                       fill="#F59E0B" stroke="#F59E0B" strokeWidth="2"/>
//               </svg>
//               <span style={{ fontWeight: '800', color: '#1F2937' }}>What You'll Win</span>
//             </div>
//             <p style={{
//               fontSize: 'clamp(1rem, 3vw, 1.2rem)',
//               color: '#6B7280',
//               margin: '0',
//               fontWeight: '500'
//             }}>
//               20 selected startups will receive this complete package
//             </p>
//           </div>

//           <div style={responsiveStyles.gridResponsive}>
//             {benefits.map((benefit, index) => (
//               <div key={index} style={{
//                 backgroundColor: 'white',
//                 padding: 'clamp(24px, 5vw, 32px)',
//                 borderRadius: '12px',
//                 boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//                 textAlign: 'left',
//                 border: '1px solid #E5E7EB'
//               }}>
//                 <div style={{ marginBottom: '16px' }}>
//                   {benefit.icon}
//                 </div>
//                 <h3 style={{
//                   fontSize: 'clamp(1.1rem, 3vw, 1.3rem)',
//                   fontWeight: '700',
//                   marginBottom: '8px',
//                   color: '#1F2937',
//                   margin: '0 0 8px 0'
//                 }}>
//                   {benefit.title}
//                 </h3>
//                 <p style={{
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                   color: '#6B7280',
//                   margin: '0',
//                   lineHeight: '1.5'
//                 }}>
//                   {benefit.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Who Can Apply Section
//   const WhoCanApplySection = () => {
//     const criteria = [
//       {
//         icon: (
//           <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{ color: '#3B82F6' }}>
//             <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" 
//                   stroke="currentColor" strokeWidth="2"/>
//             <path d="M12 7V12L15 15" stroke="currentColor" strokeWidth="2"/>
//           </svg>
//         ),
//         title: 'Indian Startup Founders',
//         description: 'Pre-seed or Seed stage companies based in India'
//       },
//       {
//         icon: (
//           <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{ color: '#3B82F6' }}>
//             <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" fill="currentColor"/>
//           </svg>
//         ),
//         title: 'MVP Ready',
//         description: 'Have a minimum viable product with some early traction'
//       },
//       {
//         icon: (
//           <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{ color: '#3B82F6' }}>
//             <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" 
//                   stroke="currentColor" strokeWidth="2"/>
//             <path d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" 
//                   stroke="currentColor" strokeWidth="2"/>
//           </svg>
//         ),
//         title: 'All Backrr Users Welcome',
//         description: 'Both new and existing users can participate'
//       },
//       {
//         icon: (
//           <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{ color: '#3B82F6' }}>
//             <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
//                   stroke="currentColor" strokeWidth="2"/>
//           </svg>
//         ),
//         title: 'Complete Your Profile',
//         description: 'Must have at least 50% profile completion on Backrr'
//       }
//     ];

//     return (
//       <div style={{
//         backgroundColor: 'white',
//         padding: 'clamp(60px, 10vw, 80px) 20px',
//         fontFamily: 'system-ui, -apple-system, sans-serif'
//       }}>
//         <div style={responsiveStyles.container}>
//           <div style={{ marginBottom: '60px', textAlign: 'center' }}>
//             <div style={{
//               fontSize: 'clamp(2rem, 5vw, 2.5rem)',
//               marginBottom: '16px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               gap: '12px',
//               flexWrap: 'wrap'
//             }}>
//               <svg width="clamp(32px, 6vw, 40px)" height="clamp(32px, 6vw, 40px)" viewBox="0 0 24 24" fill="none">
//                 <circle cx="12" cy="12" r="9" stroke="#10B981" strokeWidth="2" fill="none"/>
//                 <path d="M9 12L11 14L15 10" stroke="#10B981" strokeWidth="2"/>
//               </svg>
//               <span style={{ fontWeight: '800', color: '#1F2937' }}>Who Can Apply?</span>
//             </div>
//             <p style={{
//               fontSize: 'clamp(1rem, 3vw, 1.2rem)',
//               color: '#6B7280',
//               margin: '0',
//               fontWeight: '500'
//             }}>
//               Simple eligibility criteria to ensure the best matches for our investor network
//             </p>
//           </div>

//           <div style={responsiveStyles.gridResponsive}>
//             {criteria.map((item, index) => (
//               <div key={index} style={{
//                 backgroundColor: '#F9FAFB',
//                 padding: 'clamp(20px, 5vw, 28px)',
//                 borderRadius: '12px',
//                 textAlign: 'left',
//                 border: '1px solid #E5E7EB'
//               }}>
//                 <div style={{ marginBottom: '16px' }}>
//                   {item.icon}
//                 </div>
//                 <h3 style={{
//                   fontSize: 'clamp(1.1rem, 3vw, 1.25rem)',
//                   fontWeight: '700',
//                   marginBottom: '8px',
//                   color: '#1F2937',
//                   margin: '0 0 8px 0'
//                 }}>
//                   {item.title}
//                 </h3>
//                 <p style={{
//                   fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                   color: '#6B7280',
//                   margin: '0',
//                   lineHeight: '1.5'
//                 }}>
//                   {item.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // About Pranay Mathur Section
//   const AboutPranayMathurSection = () => (
//     <div style={{
//       backgroundColor: '#F9FAFB',
//       padding: 'clamp(60px, 10vw, 80px) 20px',
//       fontFamily: 'system-ui, -apple-system, sans-serif'
//     }}>
//       <div style={responsiveStyles.container}>
//         <h2 style={{
//           fontSize: 'clamp(2rem, 5vw, 2.5rem)',
//           fontWeight: '800',
//           marginBottom: '60px',
//           color: '#1F2937',
//           textAlign: 'center'
//         }}>
//           About Pranay Mathur
//         </h2>

//         <div style={{
//           display: 'grid',
//           gridTemplateColumns: window.innerWidth > 768 ? '1fr 400px' : '1fr',
//           gap: 'clamp(30px, 8vw, 60px)',
//           alignItems: 'center'
//         }}>
//           <div>
//             <p style={{
//               fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
//               lineHeight: '1.7',
//               color: '#4B5563',
//               marginBottom: '32px',
//               fontWeight: '400'
//             }}>
//               Pranay Mathur is the Founder & CEO of Backrr, a leading platform revolutionizing how Indian startups raise funds and connect with strategic investors. With a decade of experience backing over 2000 startups, Pranay is recognized for his impactful mentorship and deep investor network, empowering entrepreneurs to fundraise smarter and scale faster. Driven by his passion to uplift India's vibrant startup community, he's committed to bridging the gap between innovative ideas and investor capital.
//             </p>

//             <div style={{
//               display: 'flex',
//               gap: '20px',
//               alignItems: 'center',
//               flexWrap: 'wrap'
//             }}>
//               <button style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '8px',
//                 backgroundColor: '#0A66C2',
//                 color: 'white',
//                 border: 'none',
//                 padding: 'clamp(10px, 2vw, 12px) clamp(16px, 3vw, 20px)',
//                 borderRadius: '8px',
//                 fontSize: 'clamp(0.9rem, 2vw, 1rem)',
//                 fontWeight: '600',
//                 cursor: 'pointer'
//               }}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M20.447 20.452H16.893V14.883C16.893 13.555 16.866 11.846 15.041 11.846C13.188 11.846 12.905 13.291 12.905 14.785V20.452H9.351V9H12.765V10.561H12.811C13.288 9.661 14.448 8.711 16.181 8.711C19.782 8.711 20.448 11.081 20.448 14.166V20.452H20.447ZM5.337 7.433C4.193 7.433 3.274 6.507 3.274 5.368C3.274 4.23 4.194 3.305 5.337 3.305C6.477 3.305 7.401 4.23 7.401 5.368C7.401 6.507 6.476 7.433 5.337 7.433ZM7.119 20.452H3.555V9H7.119V20.452ZM22.225 0H1.771C0.792 0 0 0.774 0 1.729V22.271C0 23.227 0.792 24 1.771 24H22.222C23.2 24 24 23.227 24 22.271V1.729C24 0.774 23.2 0 22.222 0H22.225Z"/>
//                 </svg>
//                 LinkedIn
//               </button>

//               <button style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '8px',
//                 backgroundColor: 'transparent',
//                 color: '#3B82F6',
//                 border: '2px solid #3B82F6',
//                 padding: 'clamp(8px, 2vw, 10px) clamp(16px, 3vw, 20px)',
//                 borderRadius: '8px',
//                 fontSize: 'clamp(0.9rem, 2vw, 1rem)',
//                 fontWeight: '600',
//                 cursor: 'pointer'
//               }}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"/>
//                   <polyline points="22,6 12,13 2,6"/>
//                 </svg>
//                 pranay@backrr.com
//               </button>
//             </div>
//           </div>

//           <div style={{
//             display: 'flex',
//             justifyContent: 'center'
//           }}>
//             <div style={{
//               width: 'clamp(280px, 60vw, 350px)',
//               height: 'clamp(320px, 70vw, 400px)',
//               backgroundColor: '#E5E7EB',
//               borderRadius: '16px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontSize: '1.1rem',
//               color: '#6B7280',
//               textAlign: 'center',
//               backgroundImage: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//               position: 'relative',
//               overflow: 'hidden'
//             }}>
//               <span style={{ color: 'white', fontWeight: '600' }}>Pranay Mathur's Photo</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // FAQ Section
//   const FAQSection = () => {
//     const faqs = [
//       { 
//         question: "How will the winners be selected?", 
//         answer: "20 startups will be chosen based on profile quality, traction, and potential. Selection follows a first-come, first-qualified basis, so early applications have an advantage." 
//       },
//       { 
//         question: "Do I need to be a paid Backrr user?", 
//         answer: "No, both new and existing Backrr users can apply." 
//       },
//       { 
//         question: "When will winners be announced?", 
//         answer: "Within 2 weeks after July 31, 2025." 
//       },
//       { 
//         question: "What is included in a Premium Backrr account?", 
//         answer: "Advanced analytics, investor matching, and more." 
//       },
//       { 
//         question: "Can I apply if I'm not based in India?", 
//         answer: "Only Indian startup founders are eligible." 
//       },
//       { 
//         question: "What if I don't have 50% profile completion?", 
//         answer: "You'll need to complete 50% of your Backrr profile to be considered." 
//       },
//       { 
//         question: "Is there any cost to participate?", 
//         answer: "No, it's completely free!" 
//       }
//     ];

//     return (
//       <div style={{
//         backgroundColor: 'white',
//         padding: 'clamp(60px, 10vw, 80px) 20px',
//         fontFamily: 'system-ui, -apple-system, sans-serif'
//       }}>
//         <div style={{ ...responsiveStyles.container, maxWidth: '800px' }}>
//           <div style={{ textAlign: 'center', marginBottom: '60px' }}>
//             <h2 style={{
//               fontSize: 'clamp(2rem, 5vw, 2.5rem)',
//               fontWeight: '800',
//               marginBottom: '16px',
//               color: '#1F2937'
//             }}>
//               Frequently Asked Questions
//             </h2>
//             <p style={{
//               fontSize: 'clamp(1rem, 3vw, 1.2rem)',
//               color: '#6B7280',
//               margin: '0',
//               fontWeight: '400'
//             }}>
//               Got questions? We've got answers! Find everything you need to know about the giveaway.
//             </p>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//             {faqs.map((faq, index) => (
//               <div key={index} style={{
//                 border: '1px solid #E5E7EB',
//                 borderRadius: '12px',
//                 backgroundColor: 'white',
//                 overflow: 'hidden',
//                 boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
//               }}>
//                 <button
//                   onClick={() => toggleFAQ(index)}
//                   style={{
//                     width: '100%',
//                     padding: 'clamp(16px, 4vw, 24px)',
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     backgroundColor: 'transparent',
//                     border: 'none',
//                     cursor: 'pointer',
//                     textAlign: 'left',
//                     fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
//                     fontWeight: '600',
//                     color: '#1F2937',
//                     transition: 'background-color 0.2s ease'
//                   }}
//                   onMouseEnter={(e) => e.target.style.backgroundColor = '#F9FAFB'}
//                   onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//                 >
//                   <span>{faq.question}</span>

//                   <svg
//                     width="20"
//                     height="20"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     style={{
//                       transform: openFAQIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
//                       transition: 'transform 0.2s ease',
//                       color: '#6B7280',
//                       flexShrink: 0,
//                       marginLeft: '16px'
//                     }}
//                   >
//                     <path
//                       d="M6 9L12 15L18 9"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </button>

//                 <div style={{
//                   maxHeight: openFAQIndex === index ? '200px' : '0',
//                   overflow: 'hidden',
//                   transition: 'max-height 0.3s ease, padding 0.3s ease',
//                   padding: openFAQIndex === index ? '0 clamp(16px, 4vw, 24px) clamp(16px, 4vw, 24px) clamp(16px, 4vw, 24px)' : '0 clamp(16px, 4vw, 24px)',
//                   borderTop: openFAQIndex === index ? '1px solid #E5E7EB' : 'none'
//                 }}>
//                   <p style={{
//                     fontSize: 'clamp(0.9rem, 2vw, 1rem)',
//                     color: '#6B7280',
//                     lineHeight: '1.6',
//                     margin: '16px 0 0 0'
//                   }}>
//                     {faq.answer}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Call to Action Section
//   const CallToActionSection = () => (
//     <div style={{
//       background: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 50%, #EC4899 100%)',
//       padding: 'clamp(40px, 8vw, 60px) 20px',
//       textAlign: 'center',
//       color: 'white',
//       fontFamily: 'system-ui, -apple-system, sans-serif',
//       position: 'relative',
//       overflow: 'hidden'
//     }}>
//       <div style={{
//         position: 'absolute',
//         top: '20px',
//         left: '10%',
//         width: '100px',
//         height: '100px',
//         borderRadius: '50%',
//         background: 'rgba(255, 255, 255, 0.1)',
//         filter: 'blur(40px)'
//       }} />

//       <div style={{
//         position: 'absolute',
//         bottom: '20px',
//         right: '15%',
//         width: '150px',
//         height: '150px',
//         borderRadius: '50%',
//         background: 'rgba(255, 255, 255, 0.08)',
//         filter: 'blur(50px)'
//       }} />

//       <div style={{ 
//         ...responsiveStyles.container,
//         maxWidth: '900px',
//         position: 'relative',
//         zIndex: 2
//       }}>
//         <h1 style={{
//           fontSize: 'clamp(2.5rem, 6vw, 3.5rem)',
//           fontWeight: '800',
//           marginBottom: '24px',
//           lineHeight: '1.1',
//           background: 'linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)',
//           WebkitBackgroundClip: 'text',
//           WebkitTextFillColor: 'transparent',
//           backgroundClip: 'text',
//           textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
//         }}>
//           Don't Miss This Opportunity!
//         </h1>

//         <p style={{
//           fontSize: 'clamp(1.1rem, 3vw, 1.3rem)',
//           fontWeight: '400',
//           marginBottom: '40px',
//           lineHeight: '1.6',
//           opacity: '0.95',
//           maxWidth: '600px',
//           margin: '0 auto 40px auto'
//         }}>
//           Join hundreds of successful Indian startups who've already started their journey with Backrr.
//         </p>

//         <button style={{
//           background: 'linear-gradient(135deg, #FCD34D 0%, #F59E0B 100%)',
//           color: '#1F2937',
//           borderRadius: '50px',
//           padding: 'clamp(14px, 3vw, 18px) clamp(30px, 6vw, 40px)',
//           fontWeight: '700',
//           fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
//           cursor: 'pointer',
//           border: 'none',
//           display: 'inline-flex',
//           alignItems: 'center',
//           gap: '12px',
//           boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.1)',
//           transition: 'all 0.3s ease',
//           transform: 'translateY(0)'
//         }}
//         onMouseEnter={(e) => {
//           e.target.style.transform = 'translateY(-2px)';
//           e.target.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.25), 0 6px 15px rgba(0, 0, 0, 0.15)';
//         }}
//         onMouseLeave={(e) => {
//           e.target.style.transform = 'translateY(0)';
//           e.target.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.1)';
//         }}
//         >
//           <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
//             <path d="M5 9V7C5 5.89543 5.89543 5 7 5H9C10.1046 5 11 5.89543 11 7V9H5Z" />
//             <path d="M13 9V7C13 5.89543 13.8954 5 15 5H17C18.1046 5 19 5.89543 19 7V9H13Z" />
//             <path d="M5 9H19L18.4937 16.0562C18.4275 17.1499 17.5214 18 16.4237 18H7.57634C6.47859 18 5.57252 17.1499 5.50631 16.0562L5 9Z" />
//             <path d="M9 22V18H15V22H9Z" />
//           </svg>

//           Register Now

//           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
//                strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
//             <path d="M5 12H19M12 5L19 12L12 19" />
//           </svg>
//         </button>
//       </div>
//     </div>
//   );

//   return (
//     <div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
//       <BirthdayGiveawaySection />
//       <BonusSection />
//       <WhatYoullWinSection />
//       <WhoCanApplySection />
//       <AboutPranayMathurSection />
//       <FAQSection />
//       <CallToActionSection />
//     </div>
//   );
// };


// const CompleteLandingPage = () => {
//     React.useEffect(() => {
//         document.title = "Fundraising Fastforward GiveAway - Backrr";
//         // document.querySelector('meta[name="description"]').setAttribute("content", "Join the Birthday Giveaway Blast by Backrr! Win a Premium Backrr account, mentorship call, VC intros, and more. Limited spots available for Indian startups.");
//     }, []);
//     return (<>
//     <iframe src="https://fundraising-fastforward-giveaway.lovable.app" title="Fundraising Fastforward GiveAway - Backrr" style={{
//         width: '100%',
//         height: '100dvh',
//         border: 'none',
//         overflow: 'hidden',
//     }}></iframe>
//     </>)
// } 
// export default CompleteLandingPage;


// import React, { useState, useEffect } from 'react';
// import { 
//   Clock, 
//   Gift, 
//   Users, 
//   Trophy, 
//   CheckCircle, 
//   Target,
//   Sparkles,
//   ArrowRight,
//   ExternalLink,
//   X,
//   Crown,
//   Handshake,
//   TrendingUp,
//   MapPin,
//   Rocket,
//   BarChart,
//   FileText,
//   ChevronDown
// } from 'lucide-react';

// const GiveawayLanding = () => {
//   const [showExitPopup, setShowExitPopup] = useState(false);
//   const [exitIntentShown, setExitIntentShown] = useState(false);
//   const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
//   const [expandedFAQ, setExpandedFAQ] = useState(null);
//   const [isFooterVisible, setIsFooterVisible] = useState(false);

//   // Countdown Timer Effect
//   useEffect(() => {
//     const targetDate = new Date('2025-07-31T23:59:59+05:30');
//     const timer = setInterval(() => {
//       const now = new Date().getTime();
//       const distance = targetDate.getTime() - now;

//       if (distance > 0) {
//         setTimeLeft({
//           days: Math.floor(distance / (1000 * 60 * 60 * 24)),
//           hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
//           minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
//           seconds: Math.floor((distance % (1000 * 60)) / 1000)
//         });
//       } else {
//         setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
//       }
//     }, 1000);

//     return () => clearInterval(timer);
//   }, []);

//   // Sticky Footer Effect
// //   useEffect(() => {
// //     const handleScroll = () => {
// //       setIsFooterVisible(window.scrollY > 800);
// //     };
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

//   // Exit Intent Effect
//   useEffect(() => {
//     const handleMouseLeave = (e) => {
//       if (e.clientY <= 0 && !exitIntentShown) {
//         setShowExitPopup(true);
//         setExitIntentShown(true);
//       }
//     };

//     const handleBeforeUnload = (e) => {
//       if (!exitIntentShown) {
//         setShowExitPopup(true);
//         setExitIntentShown(true);
//         e.preventDefault();
//         e.returnValue = '';
//       }
//     };

//     document.addEventListener('mouseleave', handleMouseLeave);
//     window.addEventListener('beforeunload', handleBeforeUnload);

//     return () => {
//       document.removeEventListener('mouseleave', handleMouseLeave);
//       window.removeEventListener('beforeunload', handleBeforeUnload);
//     };
//   }, [exitIntentShown]);

//   const baseStyles = {
//     container: {
//       maxWidth: '1200px',
//       margin: '0 auto',
//       padding: '0 20px'
//     },
//     button: {
//       backgroundColor: '#2563eb',
//       color: 'white',
//       padding: '16px 32px',
//       borderRadius: '50px',
//       border: 'none',
//       fontSize: '18px',
//       fontWeight: '600',
//       cursor: 'pointer',
//       textDecoration: 'none',
//       display: 'inline-flex',
//       alignItems: 'center',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
//     },
//     card: {
//       backgroundColor: 'white',
//       borderRadius: '12px',
//       padding: '24px',
//       boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//       border: '2px solid #f3f4f6',
//       transition: 'all 0.3s ease'
//     },
//     gradientText: {
//       background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
//       WebkitBackgroundClip: 'text',
//       backgroundClip: 'text',
//       WebkitTextFillColor: 'transparent'
//     }
//   };

//   const benefits = [
//     {
//       icon: <Crown size={32} color="#2563eb" />,
//       title: "Free Plus Backrr Account",
//       description: "1 Year access to advanced features"
//     },
//     {
//       icon: <Users size={32} color="#2563eb" />,
//       title: "1-hour Mentorship Call",
//       description: "Personal guidance from Pranay Mathur"
//     },
//     {
//       icon: <Handshake size={32} color="#2563eb" />,
//       title: "Warm VC Intros",
//       description: "10 curated investor connections"
//     },
//     {
//       icon: <TrendingUp size={32} color="#2563eb" />,
//       title: "Enhanced Visibility",
//       description: "Priority placement in investor network"
//     }
//   ];

//   const eligibilityCriteria = [
//     {
//       icon: <MapPin size={24} color="#2563eb" />,
//       title: "Indian Startup Founders",
//       description: "Pre-seed or Seed stage companies based in India"
//     },
//     {
//       icon: <Rocket size={24} color="#2563eb" />,
//       title: "MVP Ready",
//       description: "Have a minimum viable product with some early traction"
//     },
//     {
//       icon: <Users size={24} color="#2563eb" />,
//       title: "All Backrr Users Welcome",
//       description: "Both new and existing users can participate"
//     },
//     {
//       icon: <BarChart size={24} color="#2563eb" />,
//       title: "Complete Your Profile",
//       description: "Must have at least 50% profile completion on Backrr"
//     }
//   ];

//   const faqs = [
//     {
//       question: "How will the winners be selected?",
//       answer: "20 startups will be chosen based on profile quality, traction, and potential. Selection follows a first-come, first-qualified basis, so early applications have an advantage."
//     },
//     {
//       question: "Do I need to be a paid Backrr user?",
//       answer: "No! Both free and existing paid users can apply. This giveaway is open to all qualifying startups regardless of their current Backrr subscription status."
//     },
//     {
//       question: "When will winners be announced?",
//       answer: "Winners will be announced on August 15th, 2025, via LinkedIn announcement on Backrr's official page. All participants will also receive email notifications."
//     },
//     {
//       question: "What is included in a Plus Backrr account?",
//       answer: "Plus features include advanced investor matchmaking, secure data rooms, comprehensive fundraising analytics, investor pitch feedback, priority support, and access to exclusive investor events."
//     },
//     {
//       question: "Can I apply if I'm not based in India?",
//       answer: "This giveaway is specifically designed for Indian startup founders. Your startup must be incorporated in India and targeting the Indian market primarily."
//     },
//     {
//       question: "What if I don't have 50% profile completion?",
//       answer: "You can complete your profile before or after applying. However, incomplete profiles may not be considered for the final selection. We recommend completing your profile first to maximize your chances."
//     },
//     {
//       question: "Is there any cost to participate?",
//       answer: "Absolutely not! This giveaway is completely free to participate in. No hidden costs or mandatory purchases required."
//     }
//   ];

//   return (
//     <div style={{
//       minHeight: '100dvh',
//       background: 'linear-gradient(135deg, #eff6ff, #f3e8ff, #ffffff)',
//       fontFamily: 'system-ui, -apple-system, sans-serif',
//       position: 'relative',
//       overflow: 'hidden'
//     }}>
//       {/* Floating Shapes */}
//       <div style={{
//         position: 'absolute',
//         inset: 0,
//         pointerEvents: 'none',
//         overflow: 'hidden'
//       }}>
//         <div style={{
//           position: 'absolute',
//           top: '80px',
//           left: '40px',
//           width: '64px',
//           height: '64px',
//           backgroundColor: 'rgba(37, 99, 235, 0.1)',
//           borderRadius: '50%',
//           animation: 'float 6s ease-in-out infinite'
//         }}></div>
//         <div style={{
//           position: 'absolute',
//           top: '160px',
//           right: '80px',
//           width: '48px',
//           height: '48px',
//           backgroundColor: 'rgba(168, 85, 247, 0.2)',
//           borderRadius: '8px',
//           transform: 'rotate(45deg)',
//           animation: 'float 6s ease-in-out infinite 2s'
//         }}></div>
//         <div style={{
//           position: 'absolute',
//           top: '320px',
//           right: '320px',
//           fontSize: '48px',
//           animation: 'bounce 3s infinite 1s'
//         }}>🎁</div>
//         <div style={{
//           position: 'absolute',
//           bottom: '320px',
//           left: '320px',
//           fontSize: '36px',
//           animation: 'bounce 3s infinite 3s'
//         }}>🎉</div>
//       </div>

//       {/* Header */}
//       <header style={{
//         position: 'relative',
//         zIndex: 10,
//         backgroundColor: 'rgba(255, 255, 255, 0.8)',
//         backdropFilter: 'blur(8px)',
//         borderBottom: '1px solid #e5e7eb',
//         padding: '16px 0'
//       }}>
//         <div style={{...baseStyles.container, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
//           <a href="https://backrr.com" target="_blank" rel="noopener noreferrer" style={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: '12px',
//             textDecoration: 'none',
//             color: '#111827'
//           }}>
//             <img 
//               src="/lovable-uploads/5df2a0ea-9982-427c-a68f-212ce7644249.png" 
//               alt="Backrr Logo"
//               style={{ width: '40px', height: '40px' }}
//             />
//             <span style={{ fontWeight: '700', fontSize: '20px' }}>Backrr</span>
//           </a>

//           <a 
//             href="https://www.linkedin.com/company/backrr/" 
//             target="_blank" 
//             rel="noopener noreferrer"
//             style={{ color: '#2563eb', textDecoration: 'none' }}
//           >
//             <ExternalLink size={20} />
//           </a>
//         </div>
//       </header>

//       {/* Hero Section */}
//       <section style={{
//         position: 'relative',
//         zIndex: 10,
//         padding: '80px 20px 120px',
//         textAlign: 'center'
//       }}>
//         <div style={baseStyles.container}>
//           <h1 style={{
//             fontWeight: '900',
//             fontSize: 'clamp(2.5rem, 6vw, 4.5rem)',
//             color: '#111827',
//             marginBottom: '32px',
//             lineHeight: '1.1'
//           }}>
//             <div style={{ marginBottom: '16px' }}>Fundraising Fastforward</div>
//             <div style={baseStyles.gradientText}>GiveAway</div>
//           </h1>

//           <div style={{
//             background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
//             color: 'white',
//             padding: '12px 24px',
//             borderRadius: '50px',
//             display: 'inline-block',
//             marginBottom: '24px',
//             fontWeight: '600',
//             fontSize: '18px'
//           }}>
//             Founder of Backrr
//           </div>

//           <p style={{
//             fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
//             color: '#374151',
//             marginBottom: '32px',
//             maxWidth: '800px',
//             margin: '0 auto 32px',
//             lineHeight: '1.6'
//           }}>
//             20 startups will win ₹2 Lakhs in Mentorship & Resources
//           </p>

//           {/* Countdown Timer */}
//           <div style={{ maxWidth: '600px', margin: '0 auto 48px' }}>
//             <p style={{
//               fontSize: '18px',
//               fontWeight: '600',
//               color: '#374151',
//               marginBottom: '16px'
//             }}>
//               Registration closes July 31, 2025, 11:59 PM IST
//             </p>

//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
//               gap: '16px',
//               marginBottom: '24px'
//             }}>
//               {[
//                 { value: timeLeft.days, label: 'Days' },
//                 { value: timeLeft.hours, label: 'Hours' },
//                 { value: timeLeft.minutes, label: 'Minutes' },
//                 { value: timeLeft.seconds, label: 'Seconds' }
//               ].map((item, index) => (
//                 <div key={index} style={{
//                   backgroundColor: '#2563eb',
//                   color: 'white',
//                   padding: '16px',
//                   borderRadius: '12px',
//                   textAlign: 'center',
//                   boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
//                 }}>
//                   <div style={{
//                     fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//                     fontWeight: '700',
//                     marginBottom: '4px'
//                   }}>
//                     {item.value.toString().padStart(2, '0')}
//                   </div>
//                   <div style={{
//                     fontSize: '12px',
//                     color: 'rgba(255,255,255,0.8)',
//                     textTransform: 'uppercase',
//                     letterSpacing: '1px'
//                   }}>
//                     {item.label}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div style={{ marginTop: '48px' }}>
//             <a 
//               href="https://startup.backrr.com/bdaygiveaway" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               style={{
//                 ...baseStyles.button,
//                 fontSize: '20px',
//                 padding: '20px 40px',
//                 marginBottom: '16px'
//               }}
//               onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
//               onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
//             >
//               🚀 Register Now
//               <ArrowRight style={{ marginLeft: '8px' }} size={20} />
//             </a>

//             <p style={{
//               fontSize: '28px',
//               color: '#6b7280',
//               marginTop: '16px'
//             }}>
//               ⚠️ Only first 100 qualified startups considered. Spots filling fast!
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Bonus Section */}
//       <section style={{
//         backgroundColor: '#8a42ff',
//         padding: '80px 20px',
//         color: 'white',
//         textAlign: 'center'
//       }}>
//         <div style={baseStyles.container}>
//           <h3 style={{
//             fontWeight: '700',
//             fontSize: '24px',
//             marginBottom: '16px'
//           }}>
//             Bonus for ALL Applicants
//           </h3>
//           <p style={{ fontSize: '18px' }}>
//             Every startup that applies gets FREE access to 900+ successful startup pitch deck inspirations!
//           </p>
//         </div>
//       </section>

//       {/* Benefits Section */}
//       <section style={{
//         padding: '80px 20px',
//         backgroundColor: 'white'
//       }}>
//         <div style={baseStyles.container}>
//           <div style={{ textAlign: 'center', marginBottom: '48px' }}>
//             <h2 style={{
//               fontWeight: '700',
//               fontSize: 'clamp(2rem, 5vw, 3rem)',
//               color: '#111827',
//               marginBottom: '16px'
//             }}>
//               🎁 What You'll Win
//             </h2>
//             <p style={{
//               fontSize: '18px',
//               color: '#6b7280',
//               maxWidth: '600px',
//               margin: '0 auto'
//             }}>
//               20 selected startups will receive this complete package
//             </p>
//           </div>

//           <div style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
//             gap: '24px'
//           }}>
//             {benefits.map((benefit, index) => (
//               <div key={index} style={{
//                 ...baseStyles.card,
//                 cursor: 'pointer'
//               }}
//               onMouseOver={(e) => {
//                 e.currentTarget.style.borderColor = '#2563eb';
//                 e.currentTarget.style.transform = 'scale(1.05)';
//               }}
//               onMouseOut={(e) => {
//                 e.currentTarget.style.borderColor = '#f3f4f6';
//                 e.currentTarget.style.transform = 'scale(1)';
//               }}
//               >
//                 <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
//                   <div style={{
//                     backgroundColor: '#eff6ff',
//                     padding: '12px',
//                     borderRadius: '8px',
//                     flexShrink: 0
//                   }}>
//                     {benefit.icon}
//                   </div>
//                   <div>
//                     <h3 style={{
//                       fontWeight: '700',
//                       fontSize: '20px',
//                       color: '#111827',
//                       marginBottom: '8px'
//                     }}>
//                       {benefit.title}
//                     </h3>
//                     <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
//                       {benefit.description}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Eligibility Section */}
//       <section style={{
//         padding: '80px 20px',
//         backgroundColor: '#f9fafb'
//       }}>
//         <div style={baseStyles.container}>
//           <div style={{ textAlign: 'center', marginBottom: '48px' }}>
//             <h2 style={{
//               fontWeight: '700',
//               fontSize: 'clamp(2rem, 5vw, 3rem)',
//               color: '#111827',
//               marginBottom: '16px'
//             }}>
//               🎯 Who Can Apply?
//             </h2>
//             <p style={{
//               fontSize: '18px',
//               color: '#6b7280',
//               maxWidth: '600px',
//               margin: '0 auto'
//             }}>
//               Simple eligibility criteria to ensure the best matches for our investor network
//             </p>
//           </div>

//           <div style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
//             gap: '24px'
//           }}>
//             {eligibilityCriteria.map((criterion, index) => (
//               <div key={index} style={{
//                 ...baseStyles.card,
//                 cursor: 'pointer'
//               }}
//               onMouseOver={(e) => {
//                 e.currentTarget.style.borderColor = '#2563eb';
//               }}
//               onMouseOut={(e) => {
//                 e.currentTarget.style.borderColor = '#f3f4f6';
//               }}
//               >
//                 <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
//                   <div style={{
//                     backgroundColor: '#eff6ff',
//                     padding: '12px',
//                     borderRadius: '8px',
//                     flexShrink: 0
//                   }}>
//                     {criterion.icon}
//                   </div>
//                   <div>
//                     <h3 style={{
//                       fontWeight: '600',
//                       fontSize: '18px',
//                       color: '#111827',
//                       marginBottom: '8px'
//                     }}>
//                       {criterion.title}
//                     </h3>
//                     <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
//                       {criterion.description}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* About Pranay Section */}
//       <section style={{
//         padding: '80px 20px',
//         backgroundColor: 'white'
//       }}>
//         <div style={baseStyles.container}>
//           <div style={{
//             display: 'grid',
//             gridTemplateColumns: window.innerWidth >= 1024 ? '1fr 1fr' : '1fr',
//             gap: '48px',
//             alignItems: 'center'
//           }}>
//             {/* Content */}
//             <div style={{
//               order: window.innerWidth >= 1024 ? 1 : 2,
//               textAlign: window.innerWidth >= 1024 ? 'left' : 'center'
//             }}>
//               <h2 style={{
//                 fontWeight: '700',
//                 fontSize: 'clamp(2rem, 5vw, 3rem)',
//                 color: '#111827',
//                 marginBottom: '24px'
//               }}>
//                 About Pranay Mathur
//               </h2>

//               <p style={{
//                 fontSize: '18px',
//                 color: '#374151',
//                 lineHeight: '1.7',
//                 marginBottom: '24px'
//               }}>
//                 Pranay Mathur is the Founder & CEO of Backrr, a leading platform revolutionizing how Indian startups raise funds and connect with strategic investors. With a decade of experience backing over 2000 startups, Pranay is recognized for his impactful mentorship and deep investor network, empowering entrepreneurs to fundraise smarter and scale faster. Driven by his passion to uplift India's vibrant startup community, he's committed to bridging the gap between innovative ideas and investor capital.
//               </p>

//               <a 
//                 href="https://www.linkedin.com/in/pranaymathur?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
//                 target="_blank" 
//                 rel="noopener noreferrer"
//                 style={{
//                   background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
//                   color: 'white',
//                   padding: '12px 24px',
//                   borderRadius: '50px',
//                   textDecoration: 'none',
//                   fontWeight: '600',
//                   display: 'inline-block',
//                   transition: 'all 0.3s ease',
//                   boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
//                 }}
//                 onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
//                 onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
//               >
//                 Follow on LinkedIn
//               </a>
//             </div>

//             {/* Image */}
//             <div style={{
//               order: window.innerWidth >= 1024 ? 2 : 1,
//               display: 'flex',
//               justifyContent: 'center'
//             }}>
//               <div style={{
//                 ...baseStyles.card,
//                 padding: 0,
//                 maxWidth: '400px',
//                 width: '100%'
//               }}>
//                 <img 
//                   src="/lovable-uploads/a611c71d-c46b-46a8-a2a5-874505d8bb1a.png" 
//                   alt="Pranay Mathur - Founder & CEO of Backrr"
//                   style={{
//                     width: '100%',
//                     height: '400px',
//                     objectFit: 'cover',
//                     borderRadius: '12px'
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* FAQ Section */}
//       <section style={{
//         padding: '80px 20px',
//         backgroundColor: 'white'
//       }}>
//         <div style={baseStyles.container}>
//           <div style={{ textAlign: 'center', marginBottom: '48px' }}>
//             <h2 style={{
//               fontWeight: '700',
//               fontSize: 'clamp(2rem, 5vw, 3rem)',
//               color: '#111827',
//               marginBottom: '16px'
//             }}>
//               Frequently Asked Questions
//             </h2>
//             <p style={{
//               fontSize: '18px',
//               color: '#6b7280',
//               maxWidth: '600px',
//               margin: '0 auto'
//             }}>
//               Got questions? We've got answers! Find everything you need to know about the giveaway.
//             </p>
//           </div>

//           <div style={{
//             maxWidth: '800px',
//             margin: '0 auto'
//           }}>
//             {faqs.map((faq, index) => (
//               <div key={index} style={{
//                 backgroundColor: 'white',
//                 border: '1px solid #e5e7eb',
//                 borderRadius: '8px',
//                 marginBottom: '16px',
//                 overflow: 'hidden'
//               }}>
//                 <button
//                   style={{
//                     width: '100%',
//                     padding: '20px',
//                     textAlign: 'left',
//                     backgroundColor: 'transparent',
//                     border: 'none',
//                     fontSize: '18px',
//                     fontWeight: '600',
//                     color: '#111827',
//                     cursor: 'pointer',
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center'
//                   }}
//                   onClick={() => setExpandedFAQ(expandedFAQ === index ? null : index)}
//                 >
//                   {faq.question}
//                   <ChevronDown 
//                     size={20} 
//                     style={{
//                       transform: expandedFAQ === index ? 'rotate(180deg)' : 'rotate(0deg)',
//                       transition: 'transform 0.3s ease'
//                     }}
//                   />
//                 </button>
//                 {expandedFAQ === index && (
//                   <div style={{
//                     padding: '0 20px 20px',
//                     color: '#6b7280',
//                     lineHeight: '1.6'
//                   }}>
//                     {faq.answer}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Final CTA Section */}
//       <section style={{
//         background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
//         padding: '80px 20px',
//         textAlign: 'center'
//       }}>
//         <div style={baseStyles.container}>
//           <h2 style={{
//             fontWeight: '700',
//             fontSize: 'clamp(2rem, 5vw, 3rem)',
//             color: 'white',
//             marginBottom: '24px'
//           }}>
//             Don't Miss This Opportunity!
//           </h2>
//           <p style={{
//             fontSize: '20px',
//             color: 'rgba(255,255,255,0.9)',
//             marginBottom: '32px',
//             maxWidth: '600px',
//             margin: '0 auto 32px'
//           }}>
//             Join hundreds of successful Indian startups who've already started their journey with Backrr.
//           </p>

//           <a 
//             href="https://startup.backrr.com/bdaygiveaway" 
//             target="_blank" 
//             rel="noopener noreferrer"
//             style={{
//               ...baseStyles.button,
//               background: 'rgba(255,255,255,0.2)',
//               backdropFilter: 'blur(10px)',
//               fontSize: '20px',
//               padding: '20px 40px'
//             }}
//             onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
//             onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
//           >
//             🎁 Register Now
//             <ArrowRight style={{ marginLeft: '8px' }} size={20} />
//           </a>
//         </div>
//       </section>

//       {/* Sticky Footer */}
//       {isFooterVisible && (
//         <div style={{
//           position: 'fixed',
//           bottom: 0,
//           left: 0,
//           right: 0,
//           zIndex: 40,
//           background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
//           color: 'white',
//           padding: '16px',
//           boxShadow: '0 -4px 20px rgba(0,0,0,0.1)',
//           transform: 'translateY(0)',
//           transition: 'transform 0.3s ease-in-out'
//         }}>
//           <div style={{
//             ...baseStyles.container,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             gap: '16px',
//             flexWrap: 'wrap'
//           }}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
//               <div style={{ fontSize: '24px' }}>🎁</div>
//               <div>
//                 <p style={{ fontWeight: '700', margin: 0 }}>Don't miss out!</p>
//                 <p style={{ fontSize: '14px', margin: 0, opacity: 0.8 }}>Only 100 spots available</p>
//               </div>
//             </div>

//             <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
//               <a 
//                 href="https://startup.backrr.com/bdaygiveaway" 
//                 target="_blank" 
//                 rel="noopener noreferrer"
//                 style={{
//                   ...baseStyles.button,
//                   background: 'rgba(255,255,255,0.2)',
//                   backdropFilter: 'blur(10px)',
//                   padding: '12px 24px',
//                   fontSize: '16px'
//                 }}
//               >
//                 Register Now
//                 <ArrowRight style={{ marginLeft: '8px' }} size={16} />
//               </a>

//               <button 
//                 style={{
//                   background: 'transparent',
//                   border: 'none',
//                   color: 'white',
//                   cursor: 'pointer',
//                   padding: '8px'
//                 }}
//                 onClick={() => setIsFooterVisible(false)}
//               >
//                 <X size={16} />
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Exit Intent Popup */}
//       {showExitPopup && (
//         <div style={{
//           position: 'fixed',
//           inset: 0,
//           backgroundColor: 'rgba(0,0,0,0.5)',
//           zIndex: 50,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           padding: '16px'
//         }}>
//           <div style={{
//             backgroundColor: 'white',
//             borderRadius: '12px',
//             padding: '24px',
//             maxWidth: '400px',
//             width: '100%',
//             textAlign: 'center',
//             position: 'relative'
//           }}>
//             <button
//               onClick={() => setShowExitPopup(false)}
//               style={{
//                 position: 'absolute',
//                 top: '8px',
//                 right: '8px',
//                 background: 'transparent',
//                 border: 'none',
//                 color: '#6b7280',
//                 cursor: 'pointer'
//               }}
//             >
//               <X size={20} />
//             </button>

//             <div style={{ fontSize: '48px', marginBottom: '16px' }}>✨</div>
//             <h3 style={{
//               fontWeight: '700',
//               fontSize: '20px',
//               color: '#111827',
//               marginBottom: '8px'
//             }}>
//               Wait! Don't Leave Yet!
//             </h3>
//             <p style={{
//               color: '#6b7280',
//               marginBottom: '24px',
//               lineHeight: '1.6'
//             }}>
//               You're about to miss out on a chance to win amazing rewards for your startup!
//             </p>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//               <a 
//                 href="https://startup.backrr.com/bdaygiveaway" 
//                 target="_blank" 
//                 rel="noopener noreferrer"
//                 style={{
//                   ...baseStyles.button,
//                   width: '100%',
//                   justifyContent: 'center',
//                   textDecoration: 'none'
//                 }}
//               >
//                 Register Now – It's Free!
//               </a>

//               <button 
//                 onClick={() => setShowExitPopup(false)}
//                 style={{
//                   width: '100%',
//                   padding: '12px 24px',
//                   backgroundColor: 'transparent',
//                   border: '2px solid #e5e7eb',
//                   borderRadius: '8px',
//                   cursor: 'pointer',
//                   fontWeight: '500'
//                 }}
//               >
//                 Maybe Later
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style>
//         {`
//           @keyframes float {
//             0%, 100% { transform: translateY(0px); }
//             50% { transform: translateY(-20px); }
//           }

//           @keyframes bounce {
//             0%, 100% { transform: translateY(0); }
//             50% { transform: translateY(-10px); }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default GiveawayLanding;

import React, { useState, useEffect } from 'react';
import {
    Clock,
    Gift,
    Users,
    Trophy,
    CheckCircle,
    Target,
    Sparkles,
    ArrowRight,
    ExternalLink,
    X,
    Crown,
    Handshake,
    TrendingUp,
    MapPin,
    Rocket,
    BarChart,
    FileText,
    ChevronDown
} from 'lucide-react';

import pranayImage from 'assets/pranay-mathur.png';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useToast } from 'context/ToastContext';
import { InviteInvestorToPipelineInvestors } from 'api/investors';
import { CircularProgress, Typography } from '@mui/material';
import { BLUEBORDER } from 'ui-components/CustomButton';
import theme from 'themes/theme';

const applicationLink = `/register?ref=${process.env.REACT_APP_MODE !== "production" ? "YnNoemU=" : "cnVseW4="}&utm_source=landing&utm_campaign=ffgiveaway`;
const investor_email = process.env.REACT_APP_MODE === "production" ? "vc@backrr.com" : "inv1@mailinator.com";

const GiveawayLanding = () => {
    const { addToast } = useToast();
    const [isLoading, setIsLoading] = useState(false);
    let [startup_id] = React.useState(Cookies.get("X-ST-ID") || null);
    const {
        mutateAsync: inviteInvestorAsync,
        isLoading: isInvitingInvestor,
        status: inviteInvestorStatus,
        error: inviteInvestorError,
        data: inviteInvestorResponse
    } = InviteInvestorToPipelineInvestors();
    const handleApplyClick = async () => {
        // if (startup_id) {
        //     await checkIfInvestorExistsInPipeline({ startup_id });
        // }
        if (startup_id) {
            // alert("You are already registered. Please check your email for further instructions.");
            try {
                setIsLoading(true);
                setTimeout(async () => {
                    await inviteInvestorAsync({
                        payload:
                        {
                            first_name: "",
                            last_name: "",
                            email: (investor_email)?.toLowerCase(),
                            "organization_name": "Backrr",
                            "investor_type": "angel",
                            apply_giveaway: true,
                        }, _id: startup_id
                    }).then((successResponse) => {
                        if (successResponse?.data?.statusCode === 200) {
                            // toast.error(successResponse?.data?.message)
                            addToast("Applied for Giveaway", "success")
                            setIsLoading(false);
                            navigate("/", { replace: true });
                        }
                        else if (successResponse?.data?.statusCode === 409) {
                            // toast.error(successResponse?.data?.message)
                            addToast("Applied for Giveaway", "success")
                            setIsLoading(false);
                            navigate("/", { replace: true });
                        }
                        else {
                            // toast.success(successResponse?.data?.message)
                            addToast("Error Applying for Giveaway", "error")
                        }
                    });
                }, 2000)

            } catch (error) {
                console.error("Error:", error);
            }
        }
        else {
            navigate(applicationLink, { replace: true });
            // dispatch({ type: RESET_STATE });
            // Track button click event
        }
    };
    const navigate = useNavigate()
    // const dispatch = useDispatch()
    // const currentIP = window.location.host;
    // // React.useEffect(() => {
    // //     const handleLogOut = () => {
    // //         Cookies.remove("IS_MIXPANEL_DISABLED");
    // //         dispatch({ type: RESET_STATE });
    // //         // dispatch({ type: SET_MENU, opened: false });
    // //         Cookies.remove('X-ST-JWT', { path: '/' });
    // //         Cookies.remove('X-ST-JWT', { domain: checkForDomain() });
    // //         Cookies.remove('X-ST-ID', { path: '/' });
    // //         Cookies.remove('X-ST-ID', { domain: checkForDomain() });
    // //         Cookies.remove('is_profile_complete', { path: '/' });
    // //         Cookies.remove('email', { path: '/' });
    // //         Cookies.remove('userDetails', { path: '/' });
    // //         Cookies.remove('ref', { path: '/' });
    // //         Cookies.remove('step', { path: '/' });
    // //         const cookies = document.cookie.split(";");
    // //         // dispatch({ type: SET_STARTUP_DETAILS, data: null });
    // //         // const providerCookies = Cookies.get("provider")
    // //         // if (providerCookies == "linkedin") {
    // //         //     const url = 'https://www.linkedin.com/m/logout';
    // //         //     const win = window.open(url
    // //         //         , '_blank', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=10000, top=10000, width=1, height=1, visible=none'
    // //         //     );
    // //         //     setTimeout(() => {
    // //         //         win.close();
    // //         //     }, 3000);
    // //         // }

    // //         cookies.forEach(cookie => {
    // //             const eqPos = cookie.indexOf("=");
    // //             const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    // //             document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    // //         });
    // //         // navigate('/login');
    // //     };
    // //     handleLogOut()
    // // }, [])

    const [showExitPopup, setShowExitPopup] = useState(false);
    const [exitIntentShown, setExitIntentShown] = useState(false);
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [expandedFAQ, setExpandedFAQ] = useState(null);
    const [isFooterVisible, setIsFooterVisible] = useState(false);

    // Enhanced responsive utility function
    const getScreenSize = () => {
        if (typeof window === 'undefined') return 'xs';
        const width = window.innerWidth;
        if (width < 600) return 'xs';        // Extra small (0-599px)
        if (width < 1024) return 'sm';       // Small (600-1023px)
        if (width < 1200) return 'md';       // Medium (1024-1199px)
        if (width < 1440) return 'lg';       // Large (1200-1439px)
        return 'xl';                         // Extra large (1440px+)
    };


    const [screenSize, setScreenSize] = useState(getScreenSize());

    useEffect(() => {
        const handleResize = () => setScreenSize(getScreenSize());
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Countdown Timer Effect
    useEffect(() => {
        const targetDate = new Date('2025-07-31T23:59:59+05:30');
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetDate.getTime() - now;

            if (distance > 0) {
                setTimeLeft({
                    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((distance % (1000 * 60)) / 1000)
                });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    // Sticky Footer Effect
    useEffect(() => {
        const handleScroll = () => {
            setIsFooterVisible(window.scrollY > 40);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Exit Intent Effect
    useEffect(() => {
        const handleMouseLeave = (e) => {
            if (e.clientY <= 0 && !exitIntentShown) {
                setShowExitPopup(true);
                setExitIntentShown(true);
            }
        };

        const handleBeforeUnload = (e) => {
            if (!exitIntentShown) {
                setShowExitPopup(true);
                setExitIntentShown(true);
                e.preventDefault();
                e.returnValue = '';
            }
        };

        document.addEventListener('mouseleave', handleMouseLeave);
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            document.removeEventListener('mouseleave', handleMouseLeave);
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [exitIntentShown]);

    // Enhanced responsive styles
    const getResponsiveStyles = () => ({
        // Container styles - enhanced for better responsive behavior
        container: {
            width: '100%',
            maxWidth: screenSize === 'xs' ? '100%' :
                screenSize === 'mobile' ? '100%' :
                    screenSize === 'sm' ? '100%' :
                        screenSize === 'md' ? '1024px' :
                            screenSize === 'lg' ? '1200px' : '1440px',
            margin: '0 auto',
            padding: screenSize === 'xs' ? '0 12px' :
                screenSize === 'mobile' ? '0 16px' :
                    screenSize === 'sm' ? '0 20px' :
                        screenSize === 'md' ? '0 24px' : '0 32px',
            boxSizing: 'border-box'
        },

        // Button styles - enhanced for better touch targets
        button: {
            // backgroundColor: '#2563eb',
            background: 'gray',
            color: 'white',
            padding: screenSize === 'xs' ? '14px 20px' :
                screenSize === 'mobile' ? '16px 24px' :
                    screenSize === 'sm' ? '18px 28px' : '20px 32px',
            borderRadius: '50px',
            border: 'none',
            fontSize: screenSize === 'xs' ? '14px' :
                screenSize === 'mobile' ? '16px' :
                    screenSize === 'sm' ? '17px' : '18px',
            fontWeight: '600',
            cursor: 'pointer',
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
            width: screenSize === 'xs' || screenSize === 'mobile' ? '100%' : 'auto',
            maxWidth: screenSize === 'xs' || screenSize === 'mobile' ? '100%' : 'none',
            textAlign: 'center',
            minHeight: '48px',
            boxSizing: 'border-box'
        },

        // Card styles - enhanced spacing and sizing
        card: {
            backgroundColor: 'white',
            borderRadius: screenSize === 'xs' ? '8px' : '12px',
            padding: screenSize === 'xs' ? '12px' :
                screenSize === 'mobile' ? '16px' :
                    screenSize === 'sm' ? '20px' :
                        screenSize === 'md' ? '24px' : '28px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            border: '2px solid #f3f4f6',
            transition: 'all 0.3s ease',
            width: '100%',
            boxSizing: 'border-box'
        },

        // Grid styles - better responsive breakpoints
        gridTwoColumns: {
            display: 'grid',
            gridTemplateColumns: screenSize === 'xs' ? '1fr' :
                screenSize === 'mobile' ? '1fr' :
                    screenSize === 'sm' ? '1fr' :
                        'repeat(2, 1fr)',
            gap: screenSize === 'xs' ? '12px' :
                screenSize === 'mobile' ? '16px' :
                    screenSize === 'sm' ? '20px' :
                        screenSize === 'md' ? '24px' : '28px',
            width: '100%'
        },

        // Typography - refined scaling
        heading1: {
            fontWeight: '900',
            fontSize: screenSize === 'xs' ? '1.75rem' :
                screenSize === 'mobile' ? '2rem' :
                    screenSize === 'sm' ? '2.5rem' :
                        screenSize === 'md' ? '3.5rem' :
                            screenSize === 'lg' ? '4rem' : '4.5rem',
            lineHeight: screenSize === 'xs' ? '1.2' : '1.1',
            textAlign: 'center',
            wordWrap: 'break-word',
            hyphens: 'auto'
        },

        heading2: {
            fontWeight: '700',
            fontSize: screenSize === 'xs' ? '1.5rem' :
                screenSize === 'mobile' ? '1.75rem' :
                    screenSize === 'sm' ? '2rem' :
                        screenSize === 'md' ? '2.5rem' :
                            screenSize === 'lg' ? '2.75rem' : '3rem',
            lineHeight: '1.2',
            textAlign: 'center',
            wordWrap: 'break-word',
            hyphens: 'auto'
        },

        heading3: {
            fontWeight: '700',
            fontSize: screenSize === 'xs' ? '1.125rem' :
                screenSize === 'mobile' ? '1.25rem' :
                    screenSize === 'sm' ? '1.375rem' :
                        screenSize === 'md' ? '1.5rem' : '1.625rem',
            lineHeight: '1.3'
        },

        bodyLarge: {
            fontSize: screenSize === 'xs' ? '1rem' :
                screenSize === 'mobile' ? '1.125rem' :
                    screenSize === 'sm' ? '1.25rem' :
                        screenSize === 'md' ? '1.375rem' : '1.5rem',
            lineHeight: '1.6',
            wordWrap: 'break-word'
        },

        body: {
            fontSize: screenSize === 'xs' ? '0.875rem' :
                screenSize === 'mobile' ? '1rem' :
                    screenSize === 'sm' ? '1.125rem' : '1.25rem',
            lineHeight: '1.6',
            wordWrap: 'break-word'
        },

        // Section padding - better spacing progression
        sectionPadding: {
            padding: screenSize === 'xs' ? '32px 12px' :
                screenSize === 'mobile' ? '40px 16px' :
                    screenSize === 'sm' ? '50px 20px' :
                        screenSize === 'md' ? '60px 24px' :
                            screenSize === 'lg' ? '70px 32px' : '80px 32px'
        }
    });

    const styles = getResponsiveStyles();

    const benefits = [
        {
            icon: <Crown size={screenSize === 'xs' ? 20 : screenSize === 'mobile' ? 24 : 32} color="#2563eb" />,
            title: "Free Plus Backrr Account",
            description: "1 Year access to advanced features"
        },
        {
            icon: <Users size={screenSize === 'xs' ? 20 : screenSize === 'mobile' ? 24 : 32} color="#2563eb" />,
            title: "1-hour Mentorship Call",
            description: "Personal guidance from Pranay Mathur"
        },
        {
            icon: <Handshake size={screenSize === 'xs' ? 20 : screenSize === 'mobile' ? 24 : 32} color="#2563eb" />,
            title: "Warm VC Intros",
            description: "10 curated investor connections"
        },
        {
            icon: <TrendingUp size={screenSize === 'xs' ? 20 : screenSize === 'mobile' ? 24 : 32} color="#2563eb" />,
            title: "Enhanced Visibility",
            description: "Priority placement in investor network"
        }
    ];

    const eligibilityCriteria = [
        {
            icon: <MapPin size={screenSize === 'xs' ? 20 : screenSize === 'mobile' ? 24 : 32} color="#2563eb" />,
            title: "Indian Startup Founders",
            description: "Seed stage companies based in India"
        },
        {
            icon: <Rocket size={screenSize === 'xs' ? 20 : screenSize === 'mobile' ? 24 : 32} color="#2563eb" />,
            title: "MVP Ready",
            description: "Have a minimum viable product with some early traction"
        },
        {
            icon: <Users size={screenSize === 'xs' ? 20 : screenSize === 'mobile' ? 24 : 32} color="#2563eb" />,
            title: "All Backrr Users Welcome",
            description: "Both new and existing users can participate"
        },
        {
            icon: <BarChart size={screenSize === 'xs' ? 20 : screenSize === 'mobile' ? 24 : 32} color="#2563eb" />,
            title: "Complete Your Profile",
            description: "Must have at least 50% profile completion on Backrr"
        }
    ];

    const faqs = [
        {
            question: "How will the winners be selected?",
            answer: "20 startups will be chosen based on profile quality, traction, and potential. Selection follows a first-come, first-qualified basis, so early applications have an advantage."
        },
        {
            question: "Do I need to be a paid Backrr user?",
            answer: "No! Both free and existing paid users can apply. This giveaway is open to all qualifying startups regardless of their current Backrr subscription status."
        },
        {
            question: "When will winners be announced?",
            answer: "Winners will be announced on August 15th, 2025, via LinkedIn announcement on Backrr's official page. All participants will also receive email notifications."
        },
        {
            question: "What is included in a Plus Backrr account?",
            answer: "Plus features include advanced investor matchmaking, secure data rooms, comprehensive fundraising analytics, investor pitch feedback, priority support, and access to exclusive investor events."
        },
        {
            question: "Can I apply if I'm not based in India?",
            answer: "This giveaway is specifically designed for Indian startup founders. Your startup must be incorporated in India and targeting the Indian market primarily."
        },
        {
            question: "What if I don't have 50% profile completion?",
            answer: "You can complete your profile before or after applying. However, incomplete profiles may not be considered for the final selection. We recommend completing your profile first to maximize your chances."
        },
        {
            question: "Is there any cost to participate?",
            answer: "Absolutely not! This giveaway is completely free to participate in. No hidden costs or mandatory purchases required."
        }
    ];

    return (
        <div style={{
            minHeight: '100dvh',
            background: 'linear-gradient(135deg, #eff6ff, #f3e8ff, #ffffff)',
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            position: 'relative',
            overflow: 'hidden',
            width: '100%',
            maxWidth: '100vw'
        }}>
            {/* Floating Shapes - Enhanced responsive visibility */}
            {(screenSize === 'md' || screenSize === 'lg' || screenSize === 'xl') && (
                <div style={{
                    position: 'absolute',
                    inset: 0,
                    pointerEvents: 'none',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: screenSize === 'md' ? '60px' : '80px',
                        left: screenSize === 'md' ? '30px' : '40px',
                        width: screenSize === 'md' ? '50px' : '64px',
                        height: screenSize === 'md' ? '50px' : '64px',
                        backgroundColor: 'rgba(37, 99, 235, 0.1)',
                        borderRadius: '50%',
                        animation: 'float 6s ease-in-out infinite'
                    }}></div>
                    <div style={{
                        position: 'absolute',
                        top: screenSize === 'md' ? '140px' : '160px',
                        right: screenSize === 'md' ? '60px' : '80px',
                        width: screenSize === 'md' ? '40px' : '48px',
                        height: screenSize === 'md' ? '40px' : '48px',
                        backgroundColor: 'rgba(168, 85, 247, 0.2)',
                        borderRadius: '8px',
                        transform: 'rotate(45deg)',
                        animation: 'float 6s ease-in-out infinite 2s'
                    }}></div>
                    <div style={{
                        position: 'absolute',
                        top: screenSize === 'md' ? '280px' : '320px',
                        right: screenSize === 'md' ? '280px' : '320px',
                        fontSize: screenSize === 'md' ? '36px' : '48px',
                        animation: 'bounce 3s infinite 1s'
                    }}>🎁</div>
                    <div style={{
                        position: 'absolute',
                        bottom: screenSize === 'md' ? '280px' : '320px',
                        left: screenSize === 'md' ? '280px' : '320px',
                        fontSize: screenSize === 'md' ? '28px' : '36px',
                        animation: 'bounce 3s infinite 3s'
                    }}>🎉</div>
                </div>
            )}

            {/* Header - Enhanced responsive design */}
            <header style={{
                position: 'fixed',
                top: 0,
                zIndex: 50,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(8px)',
                borderBottom: '1px solid #e5e7eb',
                padding: screenSize === 'xs' ? '10px 0' :
                    screenSize === 'mobile' ? '12px 0' : '16px 0',
                width: '100%',
                transition: 'position 10s ease'
            }}>
                <div style={{
                    ...styles.container,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <a href="https://backrr.com" target="_blank" rel="noopener noreferrer" style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: screenSize === 'xs' ? '6px' :
                            screenSize === 'mobile' ? '8px' : '12px',
                        textDecoration: 'none',
                        color: '#111827'
                    }}>
                        <img
                            src="./backrr_og.png"
                            alt="Backrr Logo"
                            style={{
                                width: screenSize === 'xs' ? '60px' :
                                    screenSize === 'mobile' ? '70px' :
                                        screenSize === 'sm' ? '80px' : '100px',
                                height: 'auto',
                                maxHeight: screenSize === 'xs' ? '24px' :
                                    screenSize === 'mobile' ? '28px' :
                                        screenSize === 'sm' ? '32px' : '40px',
                                objectFit: 'contain',
                                scale: screenSize === 'xs' ? "5" : "4",
                                marginLeft: screenSize === 'xs' ? "1rem" : "0rem"
                            }}
                        />
                    </a>

                    <a
                        href="https://www.linkedin.com/company/backrr/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: '#2563eb',
                            textDecoration: 'none',
                            padding: '8px',
                            minHeight: '44px',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <ExternalLink size={screenSize === 'xs' ? 16 : screenSize === 'mobile' ? 18 : 20} />
                    </a>
                </div>
            </header>

            {/* Hero Section - Enhanced responsive typography and spacing */}
            <section style={{
                position: 'relative',
                zIndex: 10,
                ...styles.sectionPadding,
                textAlign: 'center',
                width: '100%',
                marginTop: screenSize === 'xs' ? '4rem' :
                    screenSize === 'mobile' ? '4rem' : '3rem'
            }}>
                <div style={styles.container}>
                    <h1 style={{
                        ...styles.heading1,
                        color: '#111827',
                        marginBottom: screenSize === 'xs' ? '20px' :
                            screenSize === 'mobile' ? '24px' : '32px'
                    }}>
                        <div style={{
                            marginBottom: screenSize === 'xs' ? '6px' :
                                screenSize === 'mobile' ? '8px' : '16px'
                        }}>
                            Fundraising Fast-forward
                        </div>
                        <div style={{
                            background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
                            WebkitBackgroundClip: 'text',
                            backgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}>
                            Giveaway
                        </div>
                    </h1>

                    <div style={{
                        background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
                        color: 'white',
                        padding: screenSize === 'xs' ? '6px 12px' :
                            screenSize === 'mobile' ? '8px 16px' :
                                screenSize === 'sm' ? '10px 20px' : '12px 24px',
                        borderRadius: '50px',
                        display: 'inline-block',
                        marginBottom: screenSize === 'xs' ? '14px' :
                            screenSize === 'mobile' ? '16px' : '24px',
                        fontWeight: '600',
                        fontSize: screenSize === 'xs' ? '12px' :
                            screenSize === 'mobile' ? '14px' :
                                screenSize === 'sm' ? '16px' : '18px'
                    }}>
                        Celebrating Pranay's Birthday Week
                    </div>

                    <p style={{
                        ...styles.bodyLarge,
                        color: '#374151',
                        marginBottom: screenSize === 'xs' ? '20px' :
                            screenSize === 'mobile' ? '24px' : '32px',
                        maxWidth: '800px',
                        margin: `0 auto ${screenSize === 'xs' ? '20px' : screenSize === 'mobile' ? '24px' : '32px'}`,
                        padding: screenSize === 'xs' ? '0 8px' : '0'
                    }}>
                        20 startups will win ₹2 Lakhs in Mentorship & Resources
                    </p>

                    {/* Countdown Timer - Enhanced responsive grid */}
                    <div style={{
                        maxWidth: '600px',
                        margin: `0 auto ${screenSize === 'xs' ? '24px' : screenSize === 'mobile' ? '32px' : '48px'}`,
                        width: '100%'
                    }}>
                        {/* <p style={{
                            fontSize: screenSize === 'xs' ? '14px' :
                                screenSize === 'mobile' ? '16px' : '18px',
                            fontWeight: '600',
                            color: '#374151',
                            marginBottom: '16px',
                            padding: screenSize === 'xs' ? '0 8px' : '0'
                        }}>
                            Applications closing - July 31, 2025
                        </p> */}

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: screenSize === 'xs' ? 'repeat(2, 1fr)' :
                                screenSize === 'mobile' ? 'repeat(2, 1fr)' :
                                    'repeat(4, 1fr)',
                            gap: screenSize === 'xs' ? '8px' :
                                screenSize === 'mobile' ? '12px' : '16px',
                            marginBottom: '24px',
                            width: '100%'
                        }}>
                            {[
                                { value: timeLeft.days, label: 'Days' },
                                { value: timeLeft.hours, label: 'Hours' },
                                { value: timeLeft.minutes, label: 'Minutes' },
                                { value: timeLeft.seconds, label: 'Seconds' }
                            ].map((item, index) => (
                                <div key={index} style={{
                                    backgroundColor: '#2563eb',
                                    color: 'white',
                                    padding: screenSize === 'xs' ? '10px 6px' :
                                        screenSize === 'mobile' ? '12px 8px' :
                                            screenSize === 'sm' ? '14px 10px' : '16px',
                                    borderRadius: screenSize === 'xs' ? '8px' : '12px',
                                    textAlign: 'center',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                    minWidth: '0'
                                }}>
                                    <div style={{
                                        fontSize: screenSize === 'xs' ? '1rem' :
                                            screenSize === 'mobile' ? '1.25rem' :
                                                screenSize === 'sm' ? '1.5rem' :
                                                    screenSize === 'md' ? '1.75rem' : '2rem',
                                        fontWeight: '700',
                                        marginBottom: '2px'
                                    }}>
                                        {item.value.toString().padStart(2, '0')}
                                    </div>
                                    <div style={{
                                        fontSize: screenSize === 'xs' ? '8px' :
                                            screenSize === 'mobile' ? '9px' : '10px',
                                        color: 'rgba(255,255,255,0.8)',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        {item.label}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div style={{
                        marginTop: screenSize === 'xs' ? '24px' :
                            screenSize === 'mobile' ? '32px' : '48px',
                        width: '100%'
                    }}>
                        <button
                            // to={ applicationLink}
                            // onClick={handleApplyClick}
                            // target="_blank"
                            // rel="noopener noreferrer"
                            style={{
                                ...styles.button,
                                fontSize: screenSize === 'xs' ? '16px' :
                                    screenSize === 'mobile' ? '18px' : '20px',
                                padding: screenSize === 'xs' ? '14px 28px' :
                                    screenSize === 'mobile' ? '15px 30px' : '15px 30px',
                                marginBottom: '16px',
                                maxWidth: screenSize === 'xs' || screenSize === 'mobile' ? '320px' : 'none'
                            }}
                            disabled
                            onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                        >
                            {/* {isLoading ? <CircularProgress size={24} /> : '🚀 Apply Now'}
                            {!isLoading && <ArrowRight style={{ marginLeft: '8px' }} size={20} />} */}
                            Applications Closed
                        </button>

                     

                        {/* <p style={{
                            fontSize: screenSize === 'xs' ? '14px' :
                                screenSize === 'mobile' ? '16px' :
                                    screenSize === 'sm' ? '18px' :
                                        screenSize === 'md' ? '20px' : '24px',
                            color: '#6b7280',
                            marginTop: '16px',
                            padding: screenSize === 'xs' ? '0 8px' : '0 16px',
                            lineHeight: '1.4'
                        }}>
                            ⚠️ Only first 100 qualified startups considered. Spots filling fast!
                        </p> */}
                    </div>

                       <Typography variant='bodyTextRegular' color={theme.palette.customColors.g100} marginTop={1} sx={{ textAlign: { xs: 'center', md: "center" }, marginBottom: { xs: "2rem", sm: 0 } }}>
                                    {/* Start your startup journey now! */}
                                    Still want to try Backrr? <BLUEBORDER
                                      component="label"
                                      role={undefined}
                                      tabIndex={-1}
                                      onClick={() => {
                                        navigate("/", { replace: true });
                                      }}
                                      sx={{
                                        backgroundColor: 'transparent !important',
                                        border: "0",
                                        padding: "0"
                                      }}> Try for Free </BLUEBORDER>
                                  </Typography>
                </div>
            </section>

            {/* Bonus Section - Enhanced responsive text sizing */}
            <section style={{
                backgroundColor: '#8a42ff',
                ...styles.sectionPadding,
                color: 'white',
                textAlign: 'center',
                width: '100%'
            }}>
                <div style={styles.container}>
                    <h3 style={{
                        fontWeight: '700',
                        fontSize: screenSize === 'xs' ? '18px' :
                            screenSize === 'mobile' ? '20px' :
                                screenSize === 'sm' ? '22px' : '24px',
                        marginBottom: '16px',
                        margin: '0 0 16px 0'
                    }}>
                        Bonus for all Applicants
                    </h3>
                    <p style={{
                        fontSize: screenSize === 'xs' ? '14px' :
                            screenSize === 'mobile' ? '16px' : '18px',
                        lineHeight: '1.6',
                        margin: '0',
                        padding: screenSize === 'xs' ? '0 8px' : '0'
                    }}>
                        Every startup that applies gets FREE access to our exclusive collection of pitch decks!
                    </p>
                </div>
            </section>

            {/* Benefits Section - Enhanced responsive card layout */}
            <section style={{
                ...styles.sectionPadding,
                backgroundColor: 'white',
                width: '100%'
            }}>
                <div style={styles.container}>
                    <div style={{
                        textAlign: 'center',
                        marginBottom: screenSize === 'xs' ? '24px' :
                            screenSize === 'mobile' ? '32px' : '48px'
                    }}>
                        <h2 style={{
                            ...styles.heading2,
                            color: '#111827',
                            marginBottom: '16px'
                        }}>
                            🎁 What You'll Win
                        </h2>
                        <p style={{
                            ...styles.body,
                            color: '#6b7280',
                            maxWidth: '600px',
                            margin: '0 auto',
                            padding: screenSize === 'xs' ? '0 8px' : '0'
                        }}>
                            20 selected startups will receive this complete package
                        </p>
                    </div>

                    <div style={styles.gridTwoColumns}>
                        {benefits.map((benefit, index) => (
                            <div key={index} style={{
                                ...styles.card,
                                cursor: 'pointer'
                            }}
                                onMouseOver={(e) => {
                                    if (screenSize !== 'xs' && screenSize !== 'mobile') {
                                        e.currentTarget.style.borderColor = '#2563eb';
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                    }
                                }}
                                onMouseOut={(e) => {
                                    if (screenSize !== 'xs' && screenSize !== 'mobile') {
                                        e.currentTarget.style.borderColor = '#f3f4f6';
                                        e.currentTarget.style.transform = 'scale(1)';
                                    }
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: screenSize === 'xs' ? '8px' :
                                        screenSize === 'mobile' ? '12px' : '16px',
                                    flexDirection: screenSize === 'xs' || screenSize === 'mobile' ? 'column' : 'row',
                                    textAlign: screenSize === 'xs' || screenSize === 'mobile' ? 'center' : 'left'
                                }}>
                                    <div style={{
                                        backgroundColor: '#eff6ff',
                                        padding: screenSize === 'xs' ? '6px' :
                                            screenSize === 'mobile' ? '8px' : '12px',
                                        borderRadius: '8px',
                                        flexShrink: 0,
                                        alignSelf: screenSize === 'xs' || screenSize === 'mobile' ? 'center' : 'flex-start'
                                    }}>
                                        {benefit.icon}
                                    </div>
                                    <div style={{ flex: 1, minWidth: '0', width: "100%" }}>
                                        <h3 style={{
                                            ...styles.heading3,
                                            color: '#111827',
                                            marginBottom: '8px',
                                        }}>
                                            {benefit.title}
                                        </h3>
                                        <p style={{
                                            color: '#6b7280',
                                            lineHeight: '1.6',
                                            fontSize: screenSize === 'xs' ? '13px' :
                                                screenSize === 'mobile' ? '14px' : '16px',
                                            margin: '0'
                                        }}>
                                            {benefit.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Eligibility Section - Enhanced responsive layout */}
            <section style={{
                ...styles.sectionPadding,
                backgroundColor: '#f9fafb',
                width: '100%'
            }}>
                <div style={styles.container}>
                    <div style={{
                        textAlign: 'center',
                        marginBottom: screenSize === 'xs' ? '24px' :
                            screenSize === 'mobile' ? '32px' : '48px'
                    }}>
                        <h2 style={{
                            ...styles.heading2,
                            color: '#111827',
                            marginBottom: '16px'
                        }}>
                            🎯 Who Can Apply?
                        </h2>
                        <p style={{
                            ...styles.body,
                            color: '#6b7280',
                            maxWidth: '600px',
                            margin: '0 auto',
                            padding: screenSize === 'xs' ? '0 8px' : '0'
                        }}>
                            Simple eligibility criteria to ensure the best matches for our investor network
                        </p>
                    </div>

                    <div style={styles.gridTwoColumns}>
                        {eligibilityCriteria.map((criterion, index) => (
                            <div key={index} style={{
                                ...styles.card,
                                cursor: 'pointer'
                            }}
                                onMouseOver={(e) => {
                                    if (screenSize !== 'xs' && screenSize !== 'mobile') {
                                        e.currentTarget.style.borderColor = '#2563eb';
                                    }
                                }}
                                onMouseOut={(e) => {
                                    if (screenSize !== 'xs' && screenSize !== 'mobile') {
                                        e.currentTarget.style.borderColor = '#f3f4f6';
                                    }
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: screenSize === 'xs' ? '8px' :
                                        screenSize === 'mobile' ? '12px' : '16px',
                                    flexDirection: screenSize === 'xs' || screenSize === 'mobile' ? 'column' : 'row',
                                    textAlign: screenSize === 'xs' || screenSize === 'mobile' ? 'center' : 'left'
                                }}>
                                    <div style={{
                                        backgroundColor: '#eff6ff',
                                        padding: screenSize === 'xs' ? '8px' : '12px',
                                        borderRadius: '8px',
                                        flexShrink: 0,
                                        alignSelf: screenSize === 'xs' || screenSize === 'mobile' ? 'center' : 'flex-start'
                                    }}>
                                        {criterion.icon}
                                    </div>
                                    <div style={{ flex: 1, minWidth: '0', width: "100%" }}>
                                        <h3 style={{
                                            ...styles.heading3,
                                            color: '#111827',
                                            marginBottom: '8px',
                                            //   fontWeight: '600',
                                            //   fontSize: screenSize === 'xs' ? '15px' :
                                            //             screenSize === 'mobile' ? '16px' : '18px',
                                        }}>
                                            {criterion.title}
                                        </h3>
                                        <p style={{
                                            color: '#6b7280',
                                            lineHeight: '1.6',
                                            fontSize: screenSize === 'xs' ? '13px' :
                                                screenSize === 'mobile' ? '14px' : '16px',
                                            margin: '0'
                                        }}>
                                            {criterion.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* About Pranay Section - Enhanced responsive image and text layout */}
            <section style={{
                ...styles.sectionPadding,
                backgroundColor: 'white',
                width: '100%'
            }}>
                <div style={styles.container}>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: screenSize === 'xs' || screenSize === 'mobile' || screenSize === 'sm' ? '1fr' : '1fr 1fr',
                        gap: screenSize === 'xs' ? '20px' :
                            screenSize === 'mobile' ? '24px' : '48px',
                        alignItems: 'center'
                    }}>
                        {/* Content */}
                        <div style={{
                            order: screenSize === 'xs' || screenSize === 'mobile' || screenSize === 'sm' ? 2 : 1,
                            textAlign: screenSize === 'xs' || screenSize === 'mobile' || screenSize === 'sm' ? 'center' : 'left'
                        }}>
                            <h2 style={{
                                ...styles.heading2,
                                color: '#111827',
                                marginBottom: '24px',
                                textAlign: screenSize === 'xs' || screenSize === 'mobile' || screenSize === 'sm' ? 'center' : 'left',
                                display: screenSize === 'xs' || screenSize === 'mobile' || screenSize === 'sm' ? "none" : 'inline-block',
                            }}>
                                About Pranay Mathur
                            </h2>

                            <p style={{
                                ...styles.body,
                                color: '#374151',
                                lineHeight: '1.7',
                                marginBottom: '24px'
                            }}>
                                Pranay Mathur is the Founder & CEO of Backrr - a pioneering platform transforming how Indian startups raise capital and connect with strategic investors. A serial entrepreneur and startup mentor, Pranay has personally invested in 30+ ventures and played a key role in helping founders scale smarter.
                                <br />
                                In 2022, he founded Real Time Angel Fund, now backed by 1,000+ angel investors with over INR 150 crores deployed in early-stage startups. Known for his strategic insights and deep investor network, Pranay is committed to bridging the gap between breakthrough ideas and smart capital, empowering India’s next generation of entrepreneurs.
                            </p>

                            <a
                                href="https://www.linkedin.com/in/pranaymathur?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
                                    color: 'white',
                                    padding: screenSize === 'xs' ? '10px 20px' :
                                        screenSize === 'mobile' ? '12px 24px' : '16px 32px',
                                    borderRadius: '50px',
                                    textDecoration: 'none',
                                    fontWeight: '600',
                                    display: 'inline-block',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                    fontSize: screenSize === 'xs' ? '13px' :
                                        screenSize === 'mobile' ? '14px' : '16px'
                                }}
                                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                            >
                                Follow on LinkedIn
                            </a>
                        </div>

                        {/* Image */}
                        <div style={{
                            order: screenSize === 'xs' || screenSize === 'mobile' || screenSize === 'sm' ? 1 : 2,
                            display: 'flex',
                            flexDirection: screenSize === 'xs' || screenSize === 'mobile' || screenSize === 'sm' ? 'column' : 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <h2 style={{
                                ...styles.heading2,
                                color: '#111827',
                                marginBottom: '24px',
                                textAlign: screenSize === 'xs' || screenSize === 'mobile' || screenSize === 'sm' ? 'center' : 'left',
                                display: screenSize === 'xs' || screenSize === 'mobile' || screenSize === 'sm' ? "inline-block" : 'none',
                            }}>
                                About Pranay Mathur
                            </h2>
                            <div style={{
                                ...styles.card,
                                padding: 0,
                                maxWidth: screenSize === 'xs' ? '240px' :
                                    screenSize === 'mobile' ? '280px' : '500px',
                                width: '100%'
                            }}>
                                <img
                                    src={pranayImage}
                                    alt="Pranay Mathur - Founder & CEO of Backrr"
                                    style={{
                                        width: '100%',
                                        height: screenSize === 'xs' ? '240px' :
                                            screenSize === 'mobile' ? '280px' : '500px',
                                        objectFit: 'cover',
                                        borderRadius: screenSize === 'xs' ? '8px' : '12px'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section - Enhanced responsive accordion */}
            <section style={{
                ...styles.sectionPadding,
                backgroundColor: 'white',
                width: '100%'
            }}>
                <div style={styles.container}>
                    <div style={{
                        textAlign: 'center',
                        marginBottom: screenSize === 'xs' ? '24px' :
                            screenSize === 'mobile' ? '32px' : '48px'
                    }}>
                        <h2 style={{
                            ...styles.heading2,
                            color: '#111827',
                            marginBottom: '16px'
                        }}>
                            Frequently Asked Questions
                        </h2>
                        <p style={{
                            ...styles.body,
                            color: '#6b7280',
                            maxWidth: '600px',
                            margin: '0 auto',
                            padding: screenSize === 'xs' ? '0 8px' : '0'
                        }}>
                            Got questions? We've got answers! Find everything you need to know about the giveaway.
                        </p>
                    </div>

                    <div style={{
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        {faqs.map((faq, index) => {
                            // Calculate dynamic maxHeight based on content length
                            const estimatedLines = Math.ceil(faq.answer.length / 60);
                            const dynamicMaxHeight = estimatedLines * 24 + 40; // 24px per line + padding

                            return (
                                <div key={index} style={{
                                    backgroundColor: 'white',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    marginBottom: '16px',
                                    overflow: 'hidden',
                                    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                                    boxShadow: expandedFAQ === index ? '0 4px 12px rgba(0,0,0,0.1)' : '0 1px 3px rgba(0,0,0,0.05)'
                                }}>
                                    <button
                                        style={{
                                            width: '100%',
                                            padding: screenSize === 'xs' ? '16px' :
                                                screenSize === 'mobile' ? '18px' : '22px',
                                            textAlign: 'left',
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                            fontSize: screenSize === 'xs' ? '15px' :
                                                screenSize === 'mobile' ? '16px' : '18px',
                                            fontWeight: '600',
                                            color: '#111827',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start',
                                            gap: '16px',
                                            minHeight: '48px',
                                            transition: 'background-color 0.15s ease'
                                        }}
                                        // onMouseOver={(e) => {
                                        //     if (screenSize !== 'xs' && screenSize !== 'mobile') {
                                        //         e.target.style.backgroundColor = '#f8fafc';
                                        //     }
                                        // }}
                                        // onMouseOut={(e) => {
                                        //     e.target.style.backgroundColor = 'transparent';
                                        // }}
                                        onClick={() => setExpandedFAQ(expandedFAQ === index ? null : index)}
                                    >
                                        <span style={{ flex: 1, lineHeight: '1.4' }}>{faq.question}</span>
                                        <ChevronDown
                                            size={screenSize === 'xs' ? 18 : 20}
                                            style={{
                                                transform: expandedFAQ === index ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                                                flexShrink: 0,
                                                marginTop: '2px'
                                            }}
                                        />
                                    </button>

                                    {/* Smooth content wrapper */}
                                    <div
                                        style={{
                                            maxHeight: expandedFAQ === index ? `${dynamicMaxHeight}px` : '0px',
                                            transition: 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            overflow: 'hidden',
                                            willChange: expandedFAQ === index ? 'max-height' : 'auto'
                                        }}
                                    >
                                        <div style={{
                                            padding: screenSize === 'xs' ? '8px 16px 16px' :
                                                screenSize === 'mobile' ? '10px 18px 18px' : '12px 22px 22px',
                                            color: '#6b7280',
                                            lineHeight: '1.6',
                                            fontSize: screenSize === 'xs' ? '14px' :
                                                screenSize === 'mobile' ? '15px' : '16px',
                                            transform: expandedFAQ === index ? 'translateY(0)' : 'translateY(-8px)',
                                            opacity: expandedFAQ === index ? 1 : 0,
                                            transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0.1s, opacity 0.2s ease 0.1s'
                                        }}>
                                            {faq.answer}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                </div>
            </section>

            {/* Final CTA Section - Enhanced responsive button sizing */}
            <section style={{
                background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
                ...styles.sectionPadding,
                textAlign: 'center',
                width: '100%'
            }}>
                <div style={styles.container}>
                    <h2 style={{
                        ...styles.heading2,
                        color: 'white',
                        marginBottom: '24px'
                    }}>
                        Don't Miss This Opportunity!
                    </h2>
                    <p style={{
                        fontSize: screenSize === 'xs' ? '16px' :
                            screenSize === 'mobile' ? '18px' : '20px',
                        color: 'rgba(255,255,255,0.9)',
                        marginBottom: '32px',
                        maxWidth: '600px',
                        margin: '0 auto 32px',
                        lineHeight: '1.6',
                        padding: screenSize === 'xs' ? '0 8px' : '0'
                    }}>
                        Join hundreds of successful Indian startups who've already started their journey with Backrr.
                    </p>

                    <button
                        // to={applicationLink}
                        // onClick={handleApplyClick}
                        // target="_blank"
                        // rel="noopener noreferrer"
                        style={{
                            ...styles.button,
                            // background: 'rgba(255,255,255,0.2)',
                            backdropFilter: 'blur(10px)',
                            fontSize: screenSize === 'xs' ? '16px' :
                                screenSize === 'mobile' ? '18px' : '20px',
                            padding: screenSize === 'xs' ? '14px 28px' :
                                screenSize === 'mobile' ? '16px 32px' : '15px 30px',
                            width: screenSize === 'xs' || screenSize === 'mobile' ? '100%' : 'auto',
                            maxWidth: screenSize === 'xs' || screenSize === 'mobile' ? '320px' : 'none'
                        }}
                        disabled
                        onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                    >
                        {/* {isLoading ? <CircularProgress size={24} /> : '🚀 Apply Now'}
                        {!isLoading && <ArrowRight style={{ marginLeft: '8px' }} size={20} />} */}
                        Applications Closed
                    </button>
                </div>
            </section>

            {/* Sticky Footer - Enhanced responsive visibility and sizing */}
            {/* {isFooterVisible && (
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 40,
          background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
          color: 'white',
          padding: screenSize === 'xs' ? '10px 12px' :
                   screenSize === 'mobile' ? '12px 16px' : '16px',
          boxShadow: '0 -4px 20px rgba(0,0,0,0.1)',
          transform: 'translateY(0)',
          transition: 'transform 0.3s ease-in-out'
        }}>
          <div style={{
            ...styles.container,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            flexDirection: screenSize === 'xs' || screenSize === 'mobile' ? 'column' : 'row'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: screenSize === 'xs' ? '8px' : '12px',
              textAlign: screenSize === 'xs' || screenSize === 'mobile' ? 'center' : 'left'
            }}>
              <div style={{ 
                fontSize: screenSize === 'xs' ? '18px' :
                          screenSize === 'mobile' ? '20px' : '24px' 
              }}>🎁</div>
              <div>
                <p style={{ 
                  fontWeight: '700', 
                  margin: 0,
                  fontSize: screenSize === 'xs' ? '13px' :
                            screenSize === 'mobile' ? '14px' : '16px'
                }}>
                  Don't miss out!
                </p>
                <p style={{ 
                  fontSize: screenSize === 'xs' ? '11px' :
                            screenSize === 'mobile' ? '12px' : '14px', 
                  margin: 0, 
                  opacity: 0.8 
                }}>
                  Only 100 spots available
                </p>
              </div>
            </div>
            
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px',
              width: screenSize === 'xs' || screenSize === 'mobile' ? '100%' : 'auto'
            }}>
              <a 
                href="https://startup.backrr.com/bdaygiveaway" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  backdropFilter: 'blur(10px)',
                  color: 'white',
                  padding: screenSize === 'xs' ? '8px 16px' :
                           screenSize === 'mobile' ? '10px 20px' : '12px 24px',
                  borderRadius: '50px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: screenSize === 'xs' ? '13px' :
                            screenSize === 'mobile' ? '14px' : '16px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: screenSize === 'xs' || screenSize === 'mobile' ? 1 : 'none',
                  minHeight: '36px'
                }}
              >
                Register Now
                <ArrowRight style={{ marginLeft: '6px' }} size={14} />
              </a>
              
              <button 
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  padding: '8px',
                  flexShrink: 0,
                  minHeight: '36px',
                  minWidth: '36px'
                }}
                onClick={() => setIsFooterVisible(false)}
              >
                <X size={16} />
              </button>
            </div>
          </div>
        </div>
      )} */}

            {/* Exit Intent Popup - Enhanced responsive sizing and positioning */}
            {/* {showExitPopup && (
                <div style={{
                    position: 'fixed',
                    inset: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: screenSize === 'xs' ? '12px' :
                        screenSize === 'mobile' ? '16px' : '24px'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: screenSize === 'xs' ? '8px' : '12px',
                        padding: screenSize === 'xs' ? '16px' :
                            screenSize === 'mobile' ? '20px' : '24px',
                        maxWidth: screenSize === 'xs' ? '300px' :
                            screenSize === 'mobile' ? '320px' : '400px',
                        width: '100%',
                        textAlign: 'center',
                        position: 'relative'
                    }}>
                        <button
                            onClick={() => setShowExitPopup(false)}
                            style={{
                                position: 'absolute',
                                top: '8px',
                                right: '8px',
                                background: 'transparent',
                                border: 'none',
                                color: '#6b7280',
                                cursor: 'pointer',
                                padding: '4px',
                                minHeight: '32px',
                                minWidth: '32px'
                            }}
                        >
                            <X size={20} />
                        </button>

                        <div style={{
                            fontSize: screenSize === 'xs' ? '32px' :
                                screenSize === 'mobile' ? '36px' : '48px',
                            marginBottom: '16px'
                        }}>
                            ✨
                        </div>
                        <h3 style={{
                            fontWeight: '700',
                            fontSize: screenSize === 'xs' ? '16px' :
                                screenSize === 'mobile' ? '18px' : '20px',
                            color: '#111827',
                            marginBottom: '8px'
                        }}>
                            Wait! Don't Leave Yet!
                        </h3>
                        <p style={{
                            color: '#6b7280',
                            marginBottom: '20px',
                            lineHeight: '1.6',
                            fontSize: screenSize === 'xs' ? '13px' :
                                screenSize === 'mobile' ? '14px' : '16px'
                        }}>
                            You're about to miss out on a chance to win amazing rewards for your startup!
                        </p>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <NavLink
                                to={applicationLink}
                                // target="_blank"
                                // rel="noopener noreferrer"
                                style={{
                                    backgroundColor: '#2563eb',
                                    color: 'white',
                                    padding: screenSize === 'xs' ? '10px 18px' :
                                        screenSize === 'mobile' ? '12px 20px' : '14px 24px',
                                    borderRadius: '8px',
                                    textDecoration: 'none',
                                    fontWeight: '600',
                                    fontSize: screenSize === 'xs' ? '13px' :
                                        screenSize === 'mobile' ? '14px' : '16px',
                                    minHeight: '44px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                Apply Now
                            </NavLink>

                            <button
                                onClick={() => setShowExitPopup(false)}
                                style={{
                                    width: '100%',
                                    padding: screenSize === 'xs' ? '8px 18px' :
                                        screenSize === 'mobile' ? '10px 20px' : '12px 24px',
                                    backgroundColor: 'transparent',
                                    border: '2px solid #e5e7eb',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontWeight: '500',
                                    fontSize: screenSize === 'xs' ? '13px' :
                                        screenSize === 'mobile' ? '14px' : '16px',
                                    minHeight: '44px'
                                }}
                            >
                                Maybe Later
                            </button>
                        </div>
                    </div>
                </div>
            )} */}

            <style>
                {`
          * {
            box-sizing: border-box;
          }
          
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }

          /* Enhanced mobile touch improvements */
          button, a {
            -webkit-tap-highlight-color: transparent;
            touch-action: manipulation;
          }

          /* Improved mobile scrolling and overflow handling */
          html, body {
            max-width: 100vw;
            overflow-x: hidden;
            -webkit-overflow-scrolling: touch;
          }

          /* Better text rendering */
          * {
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }

          /* Responsive image handling */
          img {
            max-width: 100%;
            height: auto;
          }

          /* Enhanced focus styles for accessibility */
        //   a:focus {
        //     outline: 2px solid #2563eb;
        //     outline-offset: 2px;
        //   }
        `}
            </style>
        </div>
    );
};

export default GiveawayLanding;

